// saunamo-force-en build 2026-05-08T19:00 task5b — runtime hardening + late re-walks
/* Saunamo forced English cache version 1778269100 */
(function() {
  var SAUNAMO_FORCE_EN_PATCH_VERSION = '20260508-shop-english-only-guard';
  var SaunamoForceESViaEN = false;
  if (SaunamoForceESViaEN) {
    window.SaunamoForceEN = true;
    window.SaunamoForceENSilent = true;
    window.SaunamoForceENCatalogURL = window.SaunamoForceESCatalogURL ||
      (window.location.protocol + '//' + window.location.host + '/cdn/shop/t/102/assets/saunamo-force-es-catalog.json?smv=1777925200');
  }
  if (!window.SaunamoForceEN) return;

  var catalog = null;
  var common = null;
  var applying = false;
  var skipTags = { SCRIPT: true, STYLE: true, NOSCRIPT: true, TEXTAREA: true, TEMPLATE: true };

  if (!SaunamoForceESViaEN) {
    scheduleSurgicalFallbacks();
  }

  fetch(window.SaunamoForceENCatalogURL, { credentials: 'omit', cache: 'no-store' })
    .then(function(response) {
      return response.json();
    })
    .then(function(json) {
      catalog = json || {};
      common = catalog.common || {};
      applyAll();
      watchChanges();
    })
    .catch(function(error) {
      console.warn(SaunamoForceESViaEN ? '[SaunamoForceES] catalog load failed' : '[SaunamoForceEN] catalog load failed', error);
    });

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function scheduleSurgicalFallbacks() {
    var attempts = 0;
    function tick() {
      attempts += 1;
      try { applySurgicalFallbacks(); }
      catch (err) { /* swallow — keep ticking even if catalog is null mid-load */ }
      if (attempts < 60) window.setTimeout(tick, 500);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tick, { once: true });
    } else {
      tick();
    }
  }

  function applySurgicalFallbacks() {
    fixEnglishShopLinks();
    fixUsContactChannels();
    fixQuotePopupEnglishCopy();
    fixDeliverySectionCopy();
    fixApprovedSaunaCopy();
    applyVisiblePolish(document.body || document.documentElement);
    applyEmergencyShopEnglishTextFixes(document.body || document.documentElement);
    var exact = {
      'Nome completo *': 'Full name *',
      'Telefone *': 'Phone *',
      'seguidores': 'followers',
      'CLIENTE VERIFICADO': 'VERIFIED CUSTOMER',
      'Centenas de clientes felizes na Europa': 'Hundreds of happy customers across Europe',
      'Centenas de clientes felizes em toda a Europa': 'Hundreds of happy customers across Europe',
      'Preencha os seus dados e entramos em contacto em': 'Fill in your details and we will contact you within',
      'menos de 24 horas.': '24 hours.',
      '* Campos obrigatórios': '* Required fields',
      'Segunda a sexta-feira: 9:00 - 18:00': 'Monday to Friday: 9:00 - 18:00',
      'Informacoes de contacto': 'Contact information',
      'Informações de contacto': 'Contact information',
      'Empresa': 'Company',
      'Influenciadores': 'Influencers',
      'Revendedores': 'Dealers',
      'Saunas Personalizadas': 'Custom Saunas',
      'Acessórios': 'Accessories',
      'Acessorios': 'Accessories',
      'Artigos do Blog': 'Blog Posts',
      'Siga-nos no Instagram': 'Follow us on Instagram',
      'Aquecimento': 'Heating',
      'Tempo até aquecer': 'Heat-up time',
      'Materiais e ambiente': 'Materials and environment',
      'Precisa de ajuda a escolher o modelo certo?': 'Need help choosing the right model?',
      'Fale com os nossos especialistas em aquecedores!': 'Talk to our heater specialists!',
      'Talk to our specialists em aquecedores!': 'Talk to our heater specialists!',
      'Aquecedor a lenha': 'Wood-fired heater',
      'Desinfeção UV': 'UV disinfection',
      'Filtração de areia': 'Sand filtration',
      'Aquecimento elétrico': 'Electric heating',
      'Jatos de água potentes': 'Powerful water jets',
      'Forma redonda': 'Round shape',
      'Forma cúbica': 'Cube shape',
      'Forma oval': 'Oval shape',
      'Arrefece a água até 3°C / 37°F': 'Cools water to 3°C / 37°F',
      'Desintoxicacao': 'Detoxification',
      'Desintoxicação': 'Detoxification',
      'Spas Exteriores': 'Hot Tubs',
      'Spas exteriores': 'Hot Tubs',
      'Login account': 'Sign in',
      'Cart empty': 'Your cart is empty',
      'Speak to our specialist': 'Talk to a sauna specialist',
      'Request your complimentary quote': 'Request your free quote',
      "Fill in your details and we'll be in touch within less than 24 hours.": "Fill in your details and we'll be in touch within 24 hours.",
      'Helps us prepare a more accurate proposal for you.': 'Help us prepare a more accurate proposal for you.',
      'Enjoy Premium Support': 'Premium support included',
      'Unlock Personalized Experiences': 'Personalised recommendations',
      'Early Access to New Drops': 'Early access to new releases',
      'Seamless Checkout & Order Tracking': 'Faster checkout. Order tracking from purchase to install.',
      'O seu carrinho está vazio, mas podemos ajudá-lo a preenchê-lo with produtos incríveis.': 'Your cart is empty, but we can help you fill it with something worthwhile.'
    };
    var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        return exact[normalise(node.nodeValue)] ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function(textNode) {
      var original = textNode.nodeValue || '';
      var translated = exact[normalise(original)];
      if (!translated) return;
      var leading = (original.match(/^\s*/) || [''])[0];
      var trailing = (original.match(/\s*$/) || [''])[0];
      textNode.nodeValue = leading + translated + trailing;
    });
  }

  function applyEmergencyShopEnglishTextFixes(root) {
    if (!root) return;
    var replacements = [
      [/Design e Fabrico de Saunas Personalizadas/g, 'Custom Sauna Design and Manufacturing'],
      [/Precisa de ajuda a escolher o modelo certo\\?/g, 'Need help choosing the right model?'],
      [/Tempo até aquecer/g, 'Heat-up time'],
      [/Materiais e ambiente/g, 'Materials and environment'],
      [/Informacoes de contacto/g, 'Contact information'],
      [/Informações de contacto/g, 'Contact information'],
      [/Segunda a sexta-feira: 9:00 - 18:00/g, 'Monday to Friday: 9:00 - 18:00'],
      [/Escolha de Aquecimento/g, 'Heating choice'],
      [/Aquecimento eletrico/g, 'Electric heating'],
      [/Aquecimento elétrico/g, 'Electric heating'],
      [/Arrefece a água até 3°C \/ 37°F/g, 'Cools water to 3°C / 37°F'],
      [/Arrefece a agua ate 3°C \/ 37°F/g, 'Cools water to 3°C / 37°F'],
      [/Saunas Personalizadas/g, 'Custom Saunas'],
      [/Acessórios/g, 'Accessories'],
      [/Acessorios/g, 'Accessories'],
      [/Empresa/g, 'Company'],
      [/Influenciadores/g, 'Influencers'],
      [/Revendedores/g, 'Dealers'],
      [/Artigos do Blog/g, 'Blog Posts'],
      [/Siga-nos no Instagram/g, 'Follow us on Instagram'],
      [/Confiada por Empresas/g, 'Trusted by Businesses'],
      [/Confiada por Particulares e Empresas/g, 'Trusted by Private Clients and Businesses'],
      [/\\b([0-9]+(?:[.,][0-9]+)?[MK]?)\\s+seguidores\\b/g, '$1 followers'],
      [/\\bseguidores\\b/g, 'followers'],
      [/\\bAquecimento\\b/g, 'Heating']
    ];
    function replaceValue(value) {
      var next = String(value || '');
      replacements.forEach(function(rule) {
        next = next.replace(rule[0], rule[1]);
      });
      return next;
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        return normalise(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function(textNode) {
      var original = textNode.nodeValue || '';
      var next = replaceValue(original);
      if (next !== original) textNode.nodeValue = next;
    });
    if (root.querySelectorAll) {
      root.querySelectorAll('[alt], [title], [placeholder], [aria-label]').forEach(function(element) {
        if (element.closest && element.closest('#dyn-configurador, [data-saunamo-force-en-skip="true"]')) return;
        ['alt', 'title', 'placeholder', 'aria-label'].forEach(function(attribute) {
          var original = element.getAttribute(attribute);
          if (!original) return;
          var next = replaceValue(original);
          if (next !== original) element.setAttribute(attribute, next);
        });
      });
    }
  }

  function fixDeliverySectionCopy() {
    var handle = String(window.SaunamoForceENProductHandle || '').toLowerCase();
    if (!handle) return;
    var root = document.querySelector('.sauna-pdp-delivery');
    if (!root) return;
    var cards = root.querySelectorAll('.sm-cube220-del-card');
    if (!cards.length) return;
    function setText(el, value) {
      if (el) el.textContent = value;
    }
    function setChips(card, values) {
      var chips = card ? card.querySelectorAll('.sm-cube220-del-chip') : [];
      values.forEach(function(value, index) { setText(chips[index], value); });
    }
    function setCard(index, title, body, chips) {
      var card = cards[index];
      if (!card) return;
      setText(card.querySelector('h4'), title);
      setText(card.querySelector('p'), body);
      if (chips) setChips(card, chips);
    }
    if (handle === 'sauna-infravermelho-aura-110' || handle === 'sauna-infravermelho-aura-150') {
      setCard(0, 'Initial planning', 'We review the room, measurements and access with you before ordering. Aura only needs a level floor, suitable ventilation and a standard 230 V socket near the installation point.', ['Available space', 'Standard 230 V socket', 'Site access']);
      setCard(1, 'Home delivery', 'The sauna arrives in flat modules that fit together, delivered directly to the address provided. We confirm the date and access route with you in advance.');
      setCard(2, 'Simple assembly', 'Assembly takes 1-2 hours and can be done by one person — the modules fit together without special tools. If you prefer, the Saunamo team can also provide professional assembly. Connection is plug-and-play: just plug it into a 230 V socket. No electrician, no building work.');
      setCard(3, 'Ongoing support', 'After installation, we remain available — with a 3-year factory warranty, replacement parts and technical support whenever you need it.');
    } else if (handle === 'indoor-sauna-aisti-150') {
      setCard(0, 'Initial planning', 'We review the room, measurements and electrical requirements with you before ordering. Aisti requires a dedicated circuit and connection by a certified electrician — we send the complete electrical diagram for the model.', ['Available space', 'Dedicated electrical connection', 'Site access']);
      setCard(1, 'Home delivery', 'The sauna arrives in flat modules that fit together, delivered directly to the address provided. We confirm the date and access route with you in advance.');
      setCard(2, 'Assembly', 'You can assemble the Aisti yourself — we provide detailed manuals with step-by-step instructions. If you prefer, you can add Saunamo professional assembly, where our team takes care of everything. For the electrical connection, you can use your own electrician or add Saunamo’s electrical installation service.');
      setCard(3, 'Ongoing support', 'After installation, we remain available — with a 3-year factory warranty, replacement parts and technical support whenever you need it.');
    }
  }

  function fixApprovedSaunaCopy() {
    var product = currentProduct();
    if (!product) return;
    var topfold = product.sauna_topfold || null;
    var qualification = product.sauna_qualification || null;

    if (topfold) {
      document.querySelectorAll('.sm-cube220-topfold__title, .sm-cube220-buybar__name').forEach(function(element) {
        if (topfold.title && normalise(element.textContent)) element.textContent = topfold.title;
      });
      document.querySelectorAll('.sm-cube220-topfold__subtitle').forEach(function(element) {
        if (topfold.subtitle) element.textContent = topfold.subtitle;
      });
      var benefits = document.querySelectorAll('.sm-cube220-topfold__benefit-text');
      (topfold.benefits || []).forEach(function(value, index) {
        if (benefits[index]) benefits[index].textContent = value;
      });
    }

    if (qualification) {
      document.querySelectorAll('.sm-cube220-qualification-intro h3').forEach(function(element) {
        if (qualification.heading) element.textContent = qualification.heading;
      });
      var cards = document.querySelectorAll('.sm-cube220-qualification-highlights .sm-cube220-highlight');
      (qualification.highlights || []).forEach(function(item, index) {
        var card = cards[index];
        if (!card || !item) return;
        var eyebrow = card.querySelector('.sm-cube220-highlight-eyebrow');
        var title = card.querySelector('h5, h4');
        var body = card.querySelector('.sm-cube220-mobile-fold__body p, p');
        if (eyebrow && item.eyebrow) eyebrow.textContent = item.eyebrow;
        if (title && item.title) title.textContent = item.title;
        if (body && item.body) body.textContent = item.body;
      });
    }
  }

  function lookup(value) {
    var key = normalise(value);
    if (!key || !common) return '';
    var mapped = common[key];
    if (mapped) return polishLookupResult(mapped);
    return dynamicLookup(key) || '';
  }

  function polishLookupResult(value) {
    var polished = String(value || '');
    var rules = [
      [/^Recursos$/i, 'Resources'],
      [/^Contactos$/i, 'Contact'],
      [/^SALTAR PARA O CONTEÚDO$/i, 'SKIP TO CONTENT'],
      [/^Traga clareza e equilíbrio à sua rotina diária com soluções de bem-estar feitas para a vida moderna\.$/i, 'Bring clarity and balance to your daily routine with wellness solutions made for modern living.'],
      [/^BANHEIRAS DE GELO$/i, 'Ice Baths'],
      [/^A Nossa Coleção de Bem-Estar$/i, 'Our Wellness Collection'],
      [/^Fabricante de Saunas e Soluções de Hidromassagem e Banheiras de Gelo$/i, 'Manufacturer of Saunas, Hot Tubs and Ice Baths'],
      [/^Saunas Interiores$/i, 'Indoor Saunas'],
      [/^Saunas Exteriores$/i, 'Outdoor Saunas'],
      [/^Banheiras Exteriores$/i, 'Hot Tubs'],
      [/^Banheiras de Hidromassagem$/i, 'Hot Tubs'],
      [/^Banheiras de Hidromassagem para Bem-Estar Exterior$/i, 'Hot Tubs for Outdoor Wellness'],
      [/^Banheiras de Gelo$/i, 'Ice Baths'],
      [/^Aquecedores$/i, 'Heaters'],
      [/^Aquecedores de Sauna$/i, 'Sauna Heaters'],
      [/^Aquecedores de Sauna para uma Experiência Verdadeira$/i, 'Sauna Heaters for a True Sauna Experience'],
      [/^Aquecedor Wood-fired$/i, 'Wood-fired heater'],
      [/^Saunas Interiores para uma Vida Refinada$/i, 'Indoor Saunas for Refined Living'],
      [/^Saunas Exteriores Construídas para Durar$/i, 'Outdoor Saunas Built to Last'],
      [/^Banheiras de Gelo para a Terapia de Frio Definitiva$/i, 'Ice Baths for the Ultimate Cold-Therapy Routine'],
      [/^Peça o seu orçamento grátis$/i, 'Request your free quote'],
      [/^Localização \*$/i, 'Location *'],
      [/^CONTINUAR$/i, 'CONTINUE'],
      [/^([0-9.,]+ L · )1 pessoa$/i, '$11 person'],
      [/^1 pessoa$/i, '1 person'],
      [/^([0-9]+(?:-[0-9]+)?) pessoas$/i, '$1 people'],
      [/^Até ([0-9]+) pessoas$/i, 'Up to $1 people'],
      [/^Álamo termotatado$/i, 'Thermo-treated aspen'],
      [/^Álamo termotratado$/i, 'Thermo-treated aspen'],
      [/^Construído em amieiro$/i, 'Built in alder'],
      [/^Requer aquecedor de ([0-9,.]+(?:\s*[-\u2013]\s*[0-9,.]+)?\s*kW)$/i, 'Requires $1 heater'],
      [/^Compatível com aquecedor de ([0-9,.]+(?:\s*[-\u2013]\s*[0-9,.]+)?\s*kW)$/i, 'Compatible with $1 heater'],
      [/^Radiadores de espectro total$/i, 'Full-spectrum heaters'],
      [/^COMPRAR AGORA$/i, 'BUY NOW'],
      [/^Pedir orçamento gratuito$/i, 'Request a free quote'],
      [/^Início$/i, 'Home'],
      [/^Sauna Exterior$/i, 'Outdoor Sauna'],
      [/^Sauna Interior$/i, 'Indoor Sauna'],
      [/^Banheira de Gelo$/i, 'Ice Bath'],
      [/^Fabricação Europeia$/i, 'European manufacturing'],
      [/^Resistente às intempéries$/i, 'Weather-resistant'],
      [/^Aquecedor a lenha$/i, 'Wood-fired heater'],
      [/^Aquecimento elétrico$/i, 'Electric heating'],
      [/^Tipo de aquecimento$/i, 'Heating type'],
      [/^Forma cúbica$/i, 'Cube shape'],
      [/^Para quantas pessoas\? \*$/i, 'For how many people? *'],
      [/^\(pode escolher mais de um\)$/i, '(you can choose more than one)'],
      [/^A sua pergunta$/i, 'Your question'],
      [/^Tire as suas dúvidas — respondemos brevemente\.$/i, 'Ask us anything — we will get back to you shortly.'],
      [/^Ajuda-nos a preparar uma proposta mais precisa para si\.$/i, 'Help us prepare a more accurate quote for you.'],
      [/^A nossa equipa entrará em contacto consigo brevemente com uma proposta personalizada\.$/i, 'Our team will get back to you shortly with a tailored quote.'],
      [/^Por favor indique a sua localização\.$/i, 'Please enter your location.'],
      [/^Por favor indique o seu nome\.$/i, 'Please enter your name.'],
      [/^Por favor indique o seu número\.$/i, 'Please enter your phone number.'],
      [/^Por favor indique um email válido\.$/i, 'Please enter a valid email.'],
      [/^Não$/i, 'No'],
      [/^Serviço de montagem\?$/i, 'Assembly service?'],
      [/^Ecossistema de Bem-Estar Completo$/i, 'A Complete Wellness Ecosystem'],
      [/^Herança Finlandesa do Bem-Estar$/i, 'Finnish Wellness Heritage'],
      [/^Confiada por Particulares e Empresas$/i, 'Trusted by Individuals and Businesses'],
      [/^Fabricação europeia, construída para durar, com confiança em todo o mundo\.$/i, 'European craftsmanship, built to last, trusted worldwide.'],
      [/^Concebidos com os autênticos princípios finlandeses da sauna — circulação de ar adequada, distribuição correta do calor, madeiras premium e o ritual completo calor–frio–repouso\.$/i, 'Designed around authentic Finnish sauna principles — proper air circulation, correct heat distribution, premium woods and the full hot-cold-rest ritual.'],
      [/^Oferecemos um ecossistema de bem-estar de inspiração finlandesa: saunas, mergulhos a frio e spas\. Uma marca, uma experiência, um parceiro de confiança\.$/i, 'We offer a Finnish-inspired wellness ecosystem: saunas, cold plunges and hot tubs. One brand, one experience, one trusted partner.'],
      [/^Materiais selecionados especificamente para ambientes extremos: calor intenso, humidade, exposição ao frio, vibração e durabilidade em instalações exteriores\.$/i, 'Materials selected specifically for extreme environments: intense heat, humidity, cold exposure, vibration and long-term outdoor durability.'],
      [/^Fabricada na UE com materiais de alta qualidade, trabalho artesanal preciso e estética atemporal\.$/i, 'Made in the EU with high-quality materials, precise craftsmanship and timeless design.'],
      [/^Desde hotéis boutique a centros de treino de elite, os produtos Saunamo são reconhecidos pela sua durabilidade, estabilidade e desempenho ao longo do dia\.$/i, 'From boutique hotels to elite training centres, Saunamo products are recognised for their durability, stability and all-day performance.'],
      [/^Desde interiores de sauna personalizados a configurações de bem-estar exterior à medida, a Saunamo cria ambientes que se adaptam ao seu espaço, à sua visão e aos seus rituais\.$/i, 'From custom indoor sauna interiors to bespoke outdoor wellness setups, Saunamo creates environments that adapt to your space, your vision and your rituals.'],
      [/^Instaladores, eletricistas e carpinteiros especializados garantem que cada sauna, spa e mergulho a frio é instalado corretamente e em segurança — sem improviso, sem atalhos\.$/i, 'Specialised installers, electricians and carpenters ensure every sauna, hot tub and cold plunge is installed correctly and safely — no improvising, no shortcuts.'],
      [/^Oferecemos logística personalizada, envio global e assistência pós-venda cuidada para garantir que a sua instalação — seja sauna, spa ou banho de gelo — decorra sem complicações do início ao fim\.$/i, 'We offer tailored logistics, worldwide shipping and attentive after-sales support to make sure your installation — sauna, hot tub or cold plunge — runs smoothly from start to finish.'],
      [/^Entre no processo de instalação e veja como a nossa equipa transforma matérias-primas numa sauna completamente acabada — fabricada com precisão, expertise finlandesa e absoluta atenção ao detalhe\.$/i, 'Step inside the installation process and see how our team turns raw materials into a fully finished sauna — built with precision, Finnish expertise and absolute attention to detail.'],
      [/^Ver vídeo completo aqui$/i, 'Watch the full video here'],
      [/^FALAR COM VENDAS$/i, 'TALK TO SALES'],
      [/^Fale com o nosso especialista$/i, 'Talk to our specialist'],
      [/^Fale com a equipa$/i, 'Talk to our team'],
      [/^FALE COM A EQUIPA$/i, 'TALK TO OUR TEAM'],
      [/^Fale com um especialista$/i, 'Talk to a specialist'],
      [/^FALE COM UM ESPECIALISTA$/i, 'TALK TO A SPECIALIST'],
      [/^For Indoor and Utiliza[cç][aã]o exterior$/i, 'For Indoor and Outdoor Use'],
      [/^Para utiliza[cç][aã]o interior e exterior$/i, 'For Indoor and Outdoor Use'],
      [/^O serviço da Saunamo foi excelente, a sauna foi uma compra fantástica, trazendo consigo melhoria da condição cardiovascular, metabolismo acelerado, melhor sono, recuperação muscular, eliminação de toxinas, redução do stress e conteúdo poderoso para o Instagram\.$/i, "Saunamo's service was excellent. The sauna was a fantastic purchase, supporting cardiovascular health, metabolism, sleep, muscle recovery, toxin elimination, stress reduction — and content worth sharing."],
      [/^Depois de procurar durante algum tempo uma banheira de hidromassagem norueguesa para o aniversário da minha esposa, optei finalmente pela qualidade e decidi trabalhar com a Saunamo\.$/i, "After searching for a Norwegian hot tub for my wife's birthday, I finally chose quality and decided to work with Saunamo."],
      [/^⚡ Elétrico$/i, '⚡ Electric'],
      [/^Construção modular$/i, 'Modular construction'],
      [/^Energia e apoio$/i, 'Energy and support'],
      [/^Quer comprar uma sauna interior para a sua casa\?.*$/i, 'Looking to buy an indoor sauna for your home? Saunamo offers a selected collection of premium indoor saunas designed for private bathrooms, home gyms, wellness rooms and refined interiors.'],
      [/^Quer comprar uma sauna exterior para o seu jardim ou terraco\?.*$/i, 'Looking to buy an outdoor sauna for your garden or terrace? Saunamo offers a selected collection of premium outdoor saunas built from weather-resistant thermo-treated wood and designed to last outdoors for decades.'],
      [/^Concebidas para quem compreende o poder do frio,.*$/i, 'Designed for people who understand the power of cold, Saunamo ice baths offer a refined approach to cold-water therapy. Built with durable materials and high-performance cooling systems, they are ideal for regular home, wellness and professional use.'],
      [/^O aquecedor e o coracao da sauna\..*$/i, 'The heater is the heart of the sauna. Whether wood-fired or electric, the right heater should deliver balanced heat, durability and an authentic experience. Saunamo offers a selected range of high-quality sauna heaters.'],
      [/^Concebida para até seis pessoas, equilibra momentos de convívio com instantes de relaxamento individual\..*$/i, 'Designed for up to six people, the Cube 200 balances shared moments with individual relaxation. Wood-fired heating gives the experience a more authentic ritual feel, with optional electric support for added convenience.'],
      [/^Com a sua forma cilíndrica e acabamento em madeira, a Ergo traz uma presença natural e discreta a qualquer espaço exterior\..*$/i, 'With its cylindrical shape and wood finish, the Ergo brings a natural, understated presence to any outdoor space. Designed for a regular cold-water ritual, it offers a simple way to wake the body, recover energy and build a steady routine.'],
      [/Outdoor hot bathing with real heat and a clear format\./g, 'A wood-fired hot tub for relaxed outdoor living.'],
      [/^Desinfe[cç][aã]o UV$/i, 'UV disinfection'],
      [/^Filtra[cç][aã]o de areia$/i, 'Sand filtration'],
      [/^Aquecimento el[eé]trico$/i, 'Electric heating'],
      [/^Jatos de [áa]gua potentes$/i, 'Powerful water jets'],
      [/^Arrefece a [áa]gua at[eé] 3°C \/ 37°F$/i, 'Cools water to 3°C / 37°F'],
      [/^Preencha os seus dados e entramos em contacto em$/i, 'Fill in your details and we will contact you within'],
      [/^Depois de procurar durante algum tempo uma banheira de hidromassagem.*$/i, "After searching for a Norwegian hot tub for my wife's birthday, I finally chose quality and decided to work with Saunamo."],
      [/^"?It became a daily ritual\. I ordered from real Finns because I wanted the real sauna experience\.?"?$/i, "\"It's become a daily ritual. I ordered from real Finns at Saunamo — one of the best saunas I've ever seen. It's an investment in health, longevity and quality of life.\""],
      [/^"?Tornou-se um ritual diário.*$/i, "\"It's become a daily ritual. I ordered from real Finns at Saunamo — one of the best saunas I've ever seen. It's an investment in health, longevity and quality of life.\""],
      [/^O serviço da Saunamo foi excelente.*$/i, "Saunamo's service was excellent. The sauna was a fantastic purchase, supporting cardiovascular health, metabolism, sleep, muscle recovery, toxin elimination and stress reduction."],
      [/No surprises\\nFrom start to finish\./g, 'No surprises.<br>From start to finish.'],
      [/No surprises\.\\nFrom start to finish\./g, 'No surprises.<br>From start to finish.'],
      [/Wood-fired character, social capacity, and site preparation confirmed before ordering\./g, 'Wood-fired warmth, comfortable seating and practical setup details confirmed before you order.'],
      [/^Outdoor bathing format$/i, 'Made for outdoor spaces'],
      [/Designed for terraces, patios, gardens, and regular outdoor use\./g, 'Built for terraces, patios and gardens, with a square layout that is easy to place.'],
      [/^Social capacity$/i, 'Comfortable seating'],
      [/Choose the size by available space, seating needs, and preferred layout\./g, 'Choose the model that fits your space, group size and preferred seating layout.'],
      [/A real flame heats the water and creates an authentic outdoor bathing ritual\./g, 'A real flame warms the water and gives every soak a calm, traditional feel.'],
      [/The Cube Outdoor Bathtub is a square wood-fired outdoor tub for terraces, decks, patios, and architectural outdoor spaces\. Its clean geometric shape creates a strong visual presence, while the included wood heater gives an authentic hot-bathing ritual outdoors\./g, 'The Cube 200 is a square, wood-fired outdoor hot tub for terraces, decks, patios and architectural outdoor spaces. Its clean geometric shape creates a strong visual presence, while the included wood heater brings an authentic outdoor bathing ritual.'],
      [/Compact round design for social bathing/g, 'Compact round design for shared use'],
      [/A compact social format designed for frequent outdoor use\./g, 'A compact layout designed for regular outdoor use with family or friends.'],
      [/Clean lines, real fire and a compact social format\./g, 'Clean lines, real fire and a compact shape made for shared outdoor moments.'],
      [/\breal sauna volume\b/gi, 'actual sauna volume'],
      [/\breal heated volume\b/gi, 'actual heated volume'],
      [/The right output depends on real sauna volume/g, "The right output depends on the sauna's actual volume"],
      [/Choose the heater by the real sauna volume\./g, "Choose the heater by the sauna's actual volume."],
      [/Column format with a strong sauna presence/g, 'Freestanding column design with a strong presence in the sauna'],
      [/Real flame in a compact format/g, 'Real flame in a compact heater'],
      [/simple format for smaller spaces/g, 'simple design for smaller spaces'],
      [/Electric outdoor spa for regular use\./g, 'An electric outdoor spa for everyday relaxation.'],
      [/Choose by scale, seating, and available space\./g, 'Choose the model by seating needs, available space, and how you plan to use it.'],
      [/Everyday comfort without a wood-fired ritual\./g, 'Easy day-to-day comfort without lighting a fire.'],
      [/Comfortable seating by model/g, 'Seating that fits your routine'],
      [/Vellamo models range from compact use to larger family sessions\./g, 'Vellamo models range from compact personal use to larger family sessions.'],
      [/Compact format for terraces, gardens, and wellness areas/g, 'Compact footprint for terraces, gardens and wellness areas'],
      [/Plug & Play setup for simple daily use/g, 'Plug-and-play setup for simple daily use'],
      [/A dedicated tub format for controlled cold-water routines at home\./g, 'A dedicated cold-plunge tub for controlled cold-water routines at home.'],
      [/Elongated two-person format/g, 'Elongated shape with room for two'],
      [/An elongated format for a roomier cold plunge/g, 'An elongated shape for a roomier cold plunge'],
      [/elongated format creates/g, 'elongated shape creates'],
      [/A classic format for an outdoor routine/g, 'A classic setup for an outdoor routine'],
      [/Comfortable format for home use/g, 'Comfortable home layout'],
      [/Plug-and-play format for home/g, 'Plug-and-play layout for home'],
      [/in a barrel format, designed/g, 'with a barrel design, made'],
      [/Comfortable format for shared use/g, 'Comfortable layout for shared use'],
      [/^Kerbside delivery$/i, 'Pallet delivery'],
      [/We agree the date and delivery window\. The tub arrives on a pallet; weight varies between 300 and 350 kg depending on the model\./g, 'We agree the date and delivery window. The tub arrives on a pallet, so please make sure there is clear access for unloading. Weight varies from 300 to 350 kg depending on the model.'],
      [/Enough space to unload the pallet at the kerbside\./g, 'Enough space to unload the pallet near the delivery point.'],
      [/"?O serviço da Saunamo foi excelente, a sauna foi uma compra fantástica, trazendo consigo melhoria da condição cardiovascular, metabolismo acelerado, melhor sono, (?:recovery|recuperação) muscular, eliminação de toxinas, redução do stress\.?"?/gi, "\"Saunamo's service was excellent; the sauna was a fantastic purchase, supporting cardiovascular health, metabolism, sleep, muscle recovery, toxin elimination and stress reduction.\""],
      [/\bbarrel format\b/gi, 'barrel design'],
      [/^Desinfecao UV$/i, 'UV disinfection'],
      [/^Aquecimento eletrico$/i, 'Electric heating'],
      [/^Arrefece a agua ate 3 graus C$/i, 'Cools water down to 3 °C'],
      [/^Controls manuais$/i, 'Manual controls'],
      [/^Controlos manuais$/i, 'Manual controls'],
      [/^Comandos manuais$/i, 'Manual controls'],
      [/^Painel\s*\+\s*comando remoto$/i, 'Control panel + remote'],
      [/^Painel\s*\+\s*comando à distância$/i, 'Control panel + remote'],
      [/^Painel de controlo\s*\+\s*comando remoto$/i, 'Control panel + remote'],
      [/^Comando remoto$/i, 'Remote control'],
      [/^Comando à distância$/i, 'Remote control'],
      [/^Controlo integrado$/i, 'Built-in control'],
      [/^Controlos integrados$/i, 'Built-in controls'],
      [/^Kit de chaminé vendido separadamente$/i, 'Chimney set separate'],
      [/^A lenha$/i, 'Wood-fired'],
      [/^Disponivel em 9kW and 10\.5kW$/i, 'Available in 9 kW and 10.5 kW'],
      [/^CONTACTAR VENDAS$/i, 'CONTACT SALES'],
      [/^Relaxamento Profundo$/i, 'Deep relaxation'],
      [/^Recuperacao$/i, 'Recovery'],
      [/^Momentos Partilhados$/i, 'Shared moments'],
      [/^Instalacao Simples$/i, 'Simple installation'],
      [/^Saude Cardiovascular$/i, 'Cardiovascular health'],
      [/^Ligacao Social$/i, 'Social connection'],
      [/^Construcao Duravel e Isolada$/i, 'Durable insulated construction'],
      [/^Instalacao Plug and Play$/i, 'Plug-and-play installation'],
      [/^Design Finlandes$/i, 'Finnish design'],
      [/^Orientacao Especializada$/i, 'Expert guidance'],
      [/\btampaing\b/gi, 'covering'],
      [/\brecuperação\b/gi, 'recovery'],
      [/A Ofuro inspira-se na calma e na intenção dos rituais de banho japoneses, reinterpretados para a recovery em água fria\. O seu formato alongado cria uma forma mais aberta e natural de imersão, with espaço para esticar, partilhar e viver a experiência with conforto\. with acabamento em madeira quente, integra-se facilmente em jardins, terraços e espaços wellness modernos\./g, 'The Ofuro is inspired by the calm and intention of Japanese bathing rituals, reinterpreted for cold-water recovery. Its elongated format creates a more open and natural immersion experience, with room to stretch out, share the moment and enjoy the cold plunge in comfort. With a warm wood finish, it fits easily into gardens, terraces and modern wellness spaces.'],
      [/A Ofuro inspira-se na calma e na intenção dos rituais de banho japoneses, reinterpretados para a recuperação em água fria\. O seu formato alongado cria uma forma mais aberta e natural de imersão, com espaço para esticar, partilhar e viver a experiência com conforto\. Com acabamento em madeira quente, integra-se facilmente em jardins, terraços e espaços wellness modernos\./g, 'The Ofuro is inspired by the calm and intention of Japanese bathing rituals, reinterpreted for cold-water recovery. Its elongated format creates a more open and natural immersion experience, with room to stretch out, share the moment and enjoy the cold plunge in comfort. With a warm wood finish, it fits easily into gardens, terraces and modern wellness spaces.']
    ];
    rules.forEach(function(rule) {
      polished = polished.replace(rule[0], rule[1]);
    });
    return polished;
  }

  function applyVisiblePolish(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        if (!normalise(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function(textNode) {
      var original = textNode.nodeValue || '';
      var polished = polishLookupResult(original);
      if (polished !== original) textNode.nodeValue = polished;
    });
  }

  function dynamicLookup(key) {
    if (SaunamoForceESViaEN) return '';
    var translated = key;
    var changed = false;
    var configuratorMissingPrefix = 'Translation missing: en.theme.cube220_configurator.html.';
    var configuratorMissingLabels = {
      a_carregar: 'Loading',
      a_enviar: 'Sending',
      a_sua_configuracao_label: 'Your configuration',
      a_sua_proposta_foi_enviada_para_email: 'Your proposal has been sent to your email',
      aromas: 'Aromas',
      banco_encostos_2x_2_5m_led: 'Bench backrests 2 x 2.5 m with LED',
      banco_encostos_4x_2_5m_led: 'Bench backrests 4 x 2.5 m with LED',
      banheira_de_gelo: 'Cold plunge',
      banheira_de_gelo_cube: 'Cube cold plunge',
      banheira_de_gelo_ergo: 'Ergo cold plunge',
      banheira_de_gelo_ofuro: 'Ofuro cold plunge',
      como_prefere_a_parede_traseira: 'How do you prefer the rear wall?',
      configure_o_seu_produto_placeholder: 'Configure your product',
      de: 'of',
      editar: 'Edit',
      email_asterisco: 'Email *',
      entrega: 'Delivery',
      entrega_internacional: 'International delivery',
      entrega_standard: 'Standard delivery',
      estamos_a_preparar_o_configurador_placeholder: 'We are preparing the configurator',
      expandir_configurador: 'Expand configurator',
      extras: 'Extras',
      fechar_configurador: 'Close configurator',
      iva_incluido_pct: 'VAT included',
      kit_de_aromas: 'Aroma kit',
      montagem: 'Assembly',
      nome_asterisco: 'Full name *',
      parede_traseira: 'Rear wall',
      passo: 'Step',
      personalize_cada_detalhe_placeholder: 'Personalize every detail',
      produto_selecionado: 'Selected product',
      resumo: 'Summary',
      sauna: 'Sauna',
      se_adicionar_pedras_incluimos_count: 'If you add stones, we include the right quantity',
      seguinte: 'Next',
      spa: 'Hot tub',
      spa_cube_200: 'Cube 200 hot tub',
      spa_therma_200: 'Therma 200 hot tub',
      spa_therma_220: 'Therma 220 hot tub',
      spa_vellamo_l: 'Vellamo L hot tub',
      spa_vellamo_m: 'Vellamo M hot tub',
      spa_vellamo_s: 'Vellamo S hot tub',
      telefone_asterisco: 'Phone *',
      tentar_novamente: 'Try again',
      total_estimado: 'Estimated total',
      transporte: 'Transport',
      tratamento_de_madeira_exterior: 'Exterior wood treatment',
      tratamento_de_madeira_interior: 'Interior wood treatment',
      ver_resumo: 'View summary',
      ver_total_e_receber_proposta: 'View total and receive proposal',
      vidro_meia_lua_traseiro: 'Rear half-moon glass'
    };
    Object.keys(configuratorMissingLabels).forEach(function(configuratorKey) {
      var marker = configuratorMissingPrefix + configuratorKey;
      if (translated.indexOf(marker) !== -1) {
        translated = translated.split(marker).join(configuratorMissingLabels[configuratorKey]);
        changed = true;
      }
    });

    var rules = [
      [/^Traga clareza e equilíbrio à sua rotina diária com soluções de bem-estar feitas para a vida moderna\.$/i, 'Bring clarity and balance to your daily routine with wellness solutions made for modern living.'],
      [/^BANHEIRAS DE GELO$/i, 'Ice Baths'],
      [/^A Nossa Coleção de Bem-Estar$/i, 'Our Wellness Collection'],
      [/^Fabricante de Saunas e Soluções de Hidromassagem e Banheiras de Gelo$/i, 'Manufacturer of Saunas, Hot Tubs and Ice Baths'],
      [/^Saunas Interiores$/i, 'Indoor Saunas'],
      [/^Saunas Exteriores$/i, 'Outdoor Saunas'],
      [/^Banheiras Exteriores$/i, 'Hot Tubs'],
      [/^Banheiras de Hidromassagem$/i, 'Hot Tubs'],
      [/^Banheiras de Hidromassagem para Bem-Estar Exterior$/i, 'Hot Tubs for Outdoor Wellness'],
      [/^Banheiras de Gelo$/i, 'Ice Baths'],
      [/^Aquecedores$/i, 'Heaters'],
      [/^Aquecedores de Sauna$/i, 'Sauna Heaters'],
      [/^Aquecedores de Sauna para uma Experiência Verdadeira$/i, 'Sauna Heaters for a True Sauna Experience'],
      [/^Saunas Interiores para uma Vida Refinada$/i, 'Indoor Saunas for Refined Living'],
      [/^Saunas Exteriores Construídas para Durar$/i, 'Outdoor Saunas Built to Last'],
      [/^Banheiras de Gelo para a Terapia de Frio Definitiva$/i, 'Ice Baths for the Ultimate Cold-Therapy Routine'],
      [/^Quer comprar uma sauna interior para a sua casa\?.*$/i, 'Looking to buy an indoor sauna for your home? Saunamo offers a selected collection of premium indoor saunas designed for private bathrooms, home gyms, wellness rooms and refined interiors.'],
      [/^Quer comprar uma sauna exterior para o seu jardim ou terraco\?.*$/i, 'Looking to buy an outdoor sauna for your garden or terrace? Saunamo offers a selected collection of premium outdoor saunas built from weather-resistant thermo-treated wood and designed to last outdoors for decades.'],
      [/^Concebidas para quem compreende o poder do frio,.*$/i, 'Designed for people who understand the power of cold, Saunamo ice baths offer a refined approach to cold-water therapy. Built with durable materials and high-performance cooling systems, they are ideal for regular home, wellness and professional use.'],
      [/^O aquecedor e o coracao da sauna\..*$/i, 'The heater is the heart of the sauna. Whether wood-fired or electric, the right heater should deliver balanced heat, durability and an authentic experience. Saunamo offers a selected range of high-quality sauna heaters.'],
      [/^Aquecedores Wood-fired para a Experiencia Tradicional$/i, 'Wood-Fired Heaters for the Traditional Experience'],
      [/^Os aquecedores Wood-fired oferecem a forma mais tradicional.*$/i, 'Wood-fired heaters offer the most traditional way to heat a sauna, valued for their natural heat, wood aroma and authentic experience. They are ideal for outdoor saunas and for anyone looking for the classic Finnish sauna ritual.'],
      [/^Aquecedores Eletricos para a Vida Moderna$/i, 'Electric Heaters for Modern Living'],
      [/^Recursos$/i, 'Resources'],
      [/^Contactos$/i, 'Contact'],
      [/^SALTAR PARA O CONTEÚDO$/i, 'SKIP TO CONTENT'],
      [/^Peça o seu orçamento grátis$/i, 'Request your free quote'],
      [/^Localização \*$/i, 'Location *'],
      [/^CONTINUAR$/i, 'CONTINUE'],
      [/^A Saunamo tem anos de experiencia na concepcao e construcao de espacos de bem-estar para clientes privados e profissionais em toda a Europa\. A nossa equipa esta disponivel para o ajudar a encontrar a solucao certa\.$/i, 'Saunamo has years of experience designing and building wellness spaces for private and professional clients across Europe. Our team is available to help you find the right solution.'],
      [/^Concebida para até seis pessoas, equilibra momentos de convívio com instantes de relaxamento individual\..*$/i, 'Designed for up to six people, the Cube 200 balances shared moments with individual relaxation. Wood-fired heating gives the experience a more authentic ritual feel, with optional electric support for added convenience.'],
      [/^Combine a água quente da Cube 200 com uma banheira de gelo para criar uma rotina simples de calor e frio, ajustada ao espaço disponível\.$/i, 'Combine the warm water of the Cube 200 with an ice bath to create a simple hot-and-cold routine adapted to your available space.'],
      [/^Banheira de Gelo Cube$/i, 'Cube Ice Bath'],
      [/^Banheira de Gelo Ofuro$/i, 'Ofuro Ice Bath'],
      [/^A equipa Saunamo ajuda a escolher a banheira de gelo certa para a Cube 200, considerando o espaço disponível, a rotina de utilização e a preparação do local\.$/i, 'The Saunamo team helps you choose the right ice bath for the Cube 200, taking available space, use routine and site preparation into account.'],
      [/^Capacidade, sistema e pacote base seguem a informação atualmente confirmada por modelo\. O aquecedor elétrico de 3 kW é opcional nos modelos Wood-fired\.$/i, 'Capacity, system and base package follow the currently confirmed information for each model. The 3 kW electric heater is optional on wood-fired models.'],
      [/^Com a sua forma cilíndrica e acabamento em madeira, a Ergo traz uma presença natural e discreta a qualquer espaço exterior\..*$/i, 'With its cylindrical shape and wood finish, the Ergo brings a natural, understated presence to any outdoor space. Designed for a regular cold-water ritual, it offers a simple way to wake the body, recover energy and build a steady routine.'],
      [/^Sauna exterior compacta, com presença arquitetónica, para acrescentar calor ao lado da banheira de gelo\.$/i, 'A compact outdoor sauna with architectural presence, made to add heat beside the ice bath.'],
      [/^Mais espaço interior e uso até 2 pessoas\.$/i, 'More interior space and use for up to 2 people.'],
      [/^Energia e apoio$/i, 'Energy and support'],
      [/^([0-9.,]+ L · )1 pessoa$/i, '$11 person'],
      [/^1 pessoa$/i, '1 person'],
      [/^([0-9]+(?:-[0-9]+)?) pessoas$/i, '$1 people'],
      [/^Até ([0-9]+) pessoas$/i, 'Up to $1 people'],
      [/^Álamo termotatado$/i, 'Thermo-treated aspen'],
      [/^Álamo termotratado$/i, 'Thermo-treated aspen'],
      [/^Construído em amieiro$/i, 'Built in alder'],
      [/^Requer aquecedor de ([0-9,.]+(?:\s*[-\u2013]\s*[0-9,.]+)?\s*kW)$/i, 'Requires $1 heater'],
      [/^Compatível com aquecedor de ([0-9,.]+(?:\s*[-\u2013]\s*[0-9,.]+)?\s*kW)$/i, 'Compatible with $1 heater'],
      [/^Radiadores de espectro total$/i, 'Full-spectrum heaters'],
      [/^COMPRAR AGORA$/i, 'BUY NOW'],
      [/^Pedir orçamento gratuito$/i, 'Request a free quote'],
      [/^Início$/i, 'Home'],
      [/^Sauna Exterior$/i, 'Outdoor Sauna'],
      [/^Sauna Interior$/i, 'Indoor Sauna'],
      [/^Banheira de Gelo$/i, 'Ice Bath'],
      [/^Fabricação Europeia$/i, 'European manufacturing'],
      [/^Resistente às intempéries$/i, 'Weather-resistant'],
      [/^Aquecedor a lenha$/i, 'Wood-fired heater'],
      [/^Aquecimento elétrico$/i, 'Electric heating'],
      [/^Tipo de aquecimento$/i, 'Heating type'],
      [/^Forma cúbica$/i, 'Cube shape'],
      [/^Para quantas pessoas\? \*$/i, 'For how many people? *'],
      [/^\(pode escolher mais de um\)$/i, '(you can choose more than one)'],
      [/^A sua pergunta$/i, 'Your question'],
      [/^Tire as suas dúvidas — respondemos brevemente\.$/i, 'Ask us anything — we will get back to you shortly.'],
      [/^Ajuda-nos a preparar uma proposta mais precisa para si\.$/i, 'Help us prepare a more accurate quote for you.'],
      [/^A nossa equipa entrará em contacto consigo brevemente com uma proposta personalizada\.$/i, 'Our team will get back to you shortly with a tailored quote.'],
      [/^Por favor indique a sua localização\.$/i, 'Please enter your location.'],
      [/^Por favor indique o seu nome\.$/i, 'Please enter your name.'],
      [/^Por favor indique o seu número\.$/i, 'Please enter your phone number.'],
      [/^Por favor indique um email válido\.$/i, 'Please enter a valid email.'],
      [/^Não$/i, 'No'],
      [/^Serviço de montagem\?$/i, 'Assembly service?'],
      [/^Ecossistema de Bem-Estar Completo$/i, 'A Complete Wellness Ecosystem'],
      [/^Herança Finlandesa do Bem-Estar$/i, 'Finnish Wellness Heritage'],
      [/^Confiada por Particulares e Empresas$/i, 'Trusted by Individuals and Businesses'],
      [/^Fabricação europeia, construída para durar, com confiança em todo o mundo\.$/i, 'European craftsmanship, built to last, trusted worldwide.'],
      [/^Concebidos com os autênticos princípios finlandeses da sauna — circulação de ar adequada, distribuição correta do calor, madeiras premium e o ritual completo calor–frio–repouso\.$/i, 'Designed around authentic Finnish sauna principles — proper air circulation, correct heat distribution, premium woods and the full hot-cold-rest ritual.'],
      [/^Oferecemos um ecossistema de bem-estar de inspiração finlandesa: saunas, mergulhos a frio e spas\. Uma marca, uma experiência, um parceiro de confiança\.$/i, 'We offer a Finnish-inspired wellness ecosystem: saunas, cold plunges and hot tubs. One brand, one experience, one trusted partner.'],
      [/^Materiais selecionados especificamente para ambientes extremos: calor intenso, humidade, exposição ao frio, vibração e durabilidade em instalações exteriores\.$/i, 'Materials selected specifically for extreme environments: intense heat, humidity, cold exposure, vibration and long-term outdoor durability.'],
      [/^Fabricada na UE com materiais de alta qualidade, trabalho artesanal preciso e estética atemporal\.$/i, 'Made in the EU with high-quality materials, precise craftsmanship and timeless design.'],
      [/^Desde hotéis boutique a centros de treino de elite, os produtos Saunamo são reconhecidos pela sua durabilidade, estabilidade e desempenho ao longo do dia\.$/i, 'From boutique hotels to elite training centres, Saunamo products are recognised for their durability, stability and all-day performance.'],
      [/^Desde interiores de sauna personalizados a configurações de bem-estar exterior à medida, a Saunamo cria ambientes que se adaptam ao seu espaço, à sua visão e aos seus rituais\.$/i, 'From custom indoor sauna interiors to bespoke outdoor wellness setups, Saunamo creates environments that adapt to your space, your vision and your rituals.'],
      [/^Instaladores, eletricistas e carpinteiros especializados garantem que cada sauna, spa e mergulho a frio é instalado corretamente e em segurança — sem improviso, sem atalhos\.$/i, 'Specialised installers, electricians and carpenters ensure every sauna, hot tub and cold plunge is installed correctly and safely — no improvising, no shortcuts.'],
      [/^Oferecemos logística personalizada, envio global e assistência pós-venda cuidada para garantir que a sua instalação — seja sauna, spa ou banho de gelo — decorra sem complicações do início ao fim\.$/i, 'We offer tailored logistics, worldwide shipping and attentive after-sales support to make sure your installation — sauna, hot tub or cold plunge — runs smoothly from start to finish.'],
      [/^Entre no processo de instalação e veja como a nossa equipa transforma matérias-primas numa sauna completamente acabada — fabricada com precisão, expertise finlandesa e absoluta atenção ao detalhe\.$/i, 'Step inside the installation process and see how our team turns raw materials into a fully finished sauna — built with precision, Finnish expertise and absolute attention to detail.'],
      [/^Ver vídeo completo aqui$/i, 'Watch the full video here'],
      [/^FALAR COM VENDAS$/i, 'TALK TO SALES'],
      [/^Fale com o nosso especialista$/i, 'Talk to our specialist'],
      [/^Fale com a equipa$/i, 'Talk to our team'],
      [/^FALE COM A EQUIPA$/i, 'TALK TO OUR TEAM'],
      [/^Fale com um especialista$/i, 'Talk to a specialist'],
      [/^FALE COM UM ESPECIALISTA$/i, 'TALK TO A SPECIALIST'],
      [/^For Indoor and Utiliza[cç][aã]o exterior$/i, 'For Indoor and Outdoor Use'],
      [/^Para utiliza[cç][aã]o interior e exterior$/i, 'For Indoor and Outdoor Use'],
      [/^O serviço da Saunamo foi excelente, a sauna foi uma compra fantástica, trazendo consigo melhoria da condição cardiovascular, metabolismo acelerado, melhor sono, recuperação muscular, eliminação de toxinas, redução do stress e conteúdo poderoso para o Instagram\.$/i, "Saunamo's service was excellent. The sauna was a fantastic purchase, supporting cardiovascular health, metabolism, sleep, muscle recovery, toxin elimination, stress reduction — and content worth sharing."],
      [/^Depois de procurar durante algum tempo uma banheira de hidromassagem norueguesa para o aniversário da minha esposa, optei finalmente pela qualidade e decidi trabalhar com a Saunamo\.$/i, "After searching for a Norwegian hot tub for my wife's birthday, I finally chose quality and decided to work with Saunamo."],
      [/^⚡ Elétrico$/i, '⚡ Electric'],
      [/^Construção modular$/i, 'Modular construction'],
      [/^Aquecedor Wood-fired$/i, 'Wood-fired heater'],
      [/^EXPLORE A NOSSA GAMA$/i, 'EXPLORE OUR RANGE'],
      [/^Explore a nossa gama$/i, 'Explore our range'],
      [/^EXPLORAR A NOSSA GAMA$/i, 'EXPLORE OUR RANGE'],
      [/^Explorar a nossa gama$/i, 'Explore our range'],
      [/^A Empresa$/i, 'Company'],
      [/^Spas Exteriores$/i, 'Hot Tubs'],
      [/^Spas exteriores$/i, 'Hot Tubs'],
      [/^A Saunamo é uma empresa de bem-estar sediada em Portugal que ajuda people a transformar as suas casas or negócios em espaços de calma, recovery e bem-estar\. Inspirada na autêntica cultura finlandesa da sauna e no artesanato europeu de alta qualidade, criamos saunas, banheiras de gelo e spas que tornam a vida quotidiana melhor\.$/i, 'Saunamo is a wellness company based in Portugal that helps people transform homes and businesses into spaces for calm, recovery and wellbeing. Inspired by authentic Finnish sauna culture and high-quality European craftsmanship, we create saunas, cold plunges and spas that make everyday life better.'],
      [/^A Saunamo é uma empresa de bem-estar sediada em Portugal que ajuda pessoas a transformar as suas casas ou negócios em espaços de calma, recuperação e bem-estar\. Inspirada na autêntica cultura finlandesa da sauna e no artesanato europeu de alta qualidade, criamos saunas, banheiras de gelo e spas que tornam a vida quotidiana melhor\.$/i, 'Saunamo is a wellness company based in Portugal that helps people transform homes and businesses into spaces for calm, recovery and wellbeing. Inspired by authentic Finnish sauna culture and high-quality European craftsmanship, we create saunas, cold plunges and spas that make everyday life better.'],
      [/^A Saunamo foi fundada em 2023 por uma equipa finlandesa-portuguesa with uma missão clara: levar o autêntico bem-estar nórdico para além dos países nórdicos e torná-lo acessível a um público mais vasto\.$/i, 'Saunamo was founded in 2023 by a Finnish-Portuguese team with a clear mission: to bring authentic Nordic wellbeing beyond the Nordic countries and make it accessible to a wider audience.'],
      [/^Hoje essa missão evoluiu para algo maior\. A Saunamo projeta e entrega soluções de sauna standard e totalmente personalizadas, juntamente with banheiras de gelo e spas, para casas particulares, espaços de hotelaria e empresas em toda a Europa\.$/i, 'Today, that mission has grown into something larger. Saunamo designs and delivers both standard and fully customised sauna solutions, together with cold plunges and hot tubs, for private homes, hospitality spaces and businesses across Europe.'],
      [/^Na Saunamo, temos um forte sentido de responsabilidade e uma abordagem orientada para o cliente, razão pela qual a Saunamo cresceu rapidamente para se tornar uma das principais marcas de bem-estar do setor\.$/i, 'At Saunamo, we work with a strong sense of responsibility and a customer-first approach, which has helped Saunamo grow quickly into one of the leading wellbeing brands in the sector.'],
      [/^Responsabilidade$/i, 'Responsibility'],
      [/^Autenticidade$/i, 'Authenticity'],
      [/^Sede$/i, 'Headquarters'],
      [/^A sede da Saunamo está localizada em Ourém, Portugal, onde gerimos o nosso showroom, logística, control de qualidade e distribuição pelos nossos mercados\.$/i, 'Saunamo is headquartered in Ourem, Portugal, where we manage our showroom, logistics, quality control and distribution across our markets.'],
      [/^As instalações incluem aproximadamente 1\.500 m² de espaço de fábrica disponível para suportar as nossas operações atuais\.$/i, 'The facilities include approximately 1,500 m² of factory space available to support our current operations.'],
      [/^Para além da nossa unidade em Ourém, os produtos Saunamo são fabricados no Norte da Europa, with produção na Finlândia e nos países bálticos\.$/i, 'In addition to our site in Ourem, Saunamo products are manufactured in Northern Europe, with production in Finland and the Baltic countries.'],
      [/^Entre no nosso showroom em Ourém, Portugal, e experiencie as nossas soluções de bem-estar num ambiente calmo e cuidadosamente concebido\. Explore materiais, acabamentos e layouts ao vivo, sinta a qualidade do artesanato e compreenda o que define um espaço de bem-estar bem construído\.$/i, 'Step into our showroom in Ourem, Portugal, and experience our wellbeing solutions in a calm, carefully designed setting. Explore materials, finishes and layouts in person, feel the quality of the craftsmanship and understand what defines a well-built wellbeing space.'],
      [/^Os nossos especialistas estão disponíveis para o guiar pelas opções e ajudá-lo a criar uma solução que se adapte ao seu espaço, necessidades e estilo de vida\.$/i, 'Our specialists are available to guide you through the options and help you create a solution that fits your space, needs and lifestyle.'],
      [/^Nome completo \*$/i, 'Full name *'],
      [/^Telefone \*$/i, 'Phone *'],
      [/^([0-9.,]+[MK]?)\s*seguidores$/i, '$1 followers'],
      [/^CLIENTE VERIFICADO$/i, 'VERIFIED CUSTOMER'],
      [/^Segunda a sexta-feira: 9:00 - 18:00$/i, 'Monday to Friday: 9:00 - 18:00'],
      [/^What defines the Circulo$/i, 'What defines the Circle'],
      [/^Integracao$/i, 'Integration'],
      [/^Valores$/i, 'Values'],
      [/^Habitos Diarios$/i, 'Daily Habits'],
      [/^Inspirar$/i, 'Inspiration'],
      [/^Arquitetos e Designers$/i, 'Architects and Designers'],
      [/^Empreiteiros$/i, 'Contractors'],
      [/^Como Trabalhamos$/i, 'How We Work'],
      [/^O seu carrinho está vazio, mas podemos ajudá-lo a preenchê-lo with produtos incríveis\.$/i, 'Your cart is empty, but we can help you fill it with something worthwhile.'],
      [/^The data to be registered are obtained from the customer through messages sent via the forms on the saunamo\.pt website, by email, telephone, social media services, contracts, customer meetings and other situations in which the customer provides their information\.$/i, 'The data to be registered are obtained from the customer through messages sent via the forms on the saunamo.shop website, by email, telephone, social media services, contracts, customer meetings and other situations in which the customer provides their information.'],
      [/^Nordic Homesteads LDA, NIF PT517939126$/i, 'Arbor Eco LDA, NIF PT517939126'],
      [/^info@saunamo\.pt$/i, 'info@saunamo.shop'],
      [/^Quer esteja a criar um espaço de bem-estar privado em casa ou uma instalação profissional para o seu negócio, a Saunamo projeta e fabrica saunas, banhos de gelo e banheiras de hidromassagem para desempenho a longo prazo\.$/i, 'Whether you are creating a private wellness space at home or a professional installation for your business, Saunamo designs and builds saunas, cold plunges and hot tubs for long-term performance.'],
      [/^Baseados nos princípios finlandeses da sauna e fabricados na Europa, todos os produtos Saunamo são concebidos para durabilidade, conforto e desempenho térmico consistente em ambientes residenciais e comerciais\.$/i, 'Based on Finnish sauna principles and made in Europe, every Saunamo product is designed for durability, comfort and consistent thermal performance in residential and commercial settings.'],
      [/^ORÇAMENTO$/i, 'QUOTE'],
      [/^Orçamento$/i, 'Quote'],
      [/^Desde$/i, 'From'],
      [/^SHOP NOW$/i, 'BUY NOW'],
      [/^Shop now$/i, 'Buy now'],
      [/^Talk To Sales$/i, 'Talk to sales'],
      [/^Iniciar Whatsapp$/i, 'Start WhatsApp'],
      [/^Saunas Personalizadas$/i, 'Custom Saunas'],
      [/^Outdoor tubs$/i, 'Hot Tubs'],
      [/^Forma redonda$/i, 'Round shape'],
      [/^Forma oval$/i, 'Oval shape'],
      [/^Nome completo$/i, 'Full name'],
      [/^Nome completo \*$/i, 'Full name *'],
      [/^Telefone$/i, 'Phone'],
      [/^Telefone \*$/i, 'Phone *'],
      [/^([0-9]+(?:[.,][0-9]+)?[MK]?) seguidores$/i, '$1 followers'],
      [/^seguidores$/i, 'followers'],
      [/^CLIENTE VERIFICADO$/i, 'VERIFIED CUSTOMER'],
      [/^Enviar mensagem$/i, 'Send message'],
      [/^Mensagem enviada!$/i, 'Message sent!'],
      [/^A few moredetalhes$/i, 'A few more details'],
      [/^A few moredetails$/i, 'A few more details'],
      [/\bdetalhes\b/gi, 'details'],
      [/^Sauna à Medida$/i, 'Custom sauna'],
      [/^Sauna Infravermelhos$/i, 'Infrared sauna'],
      [/^Outro$/i, 'Other'],
      [/^Sim$/i, 'Yes'],
      [/^"It became a daily ritual\. I ordered from real Finns because I wanted the real sauna experience\."$/i, "\"It's become a daily ritual. I ordered from real Finns at Saunamo — one of the best saunas I've ever seen. It's an investment in health, longevity and quality of life.\""],
      [/^"Tornou-se um ritual diário.*$/i, "\"It's become a daily ritual. I ordered from real Finns at Saunamo — one of the best saunas I've ever seen. It's an investment in health, longevity and quality of life.\""],
      [/^"O serviço da Saunamo foi excelente, a sauna foi uma compra fantástica, trazendo consigo melhoria da condição cardiovascular, metabolismo acelerado, melhor sono, recuperação muscular, eliminação de toxinas, redução do stress\."$/i, "\"Saunamo's service was excellent; the sauna was a fantastic purchase, supporting cardiovascular health, metabolism, sleep, muscle recovery, toxin elimination and stress reduction.\""],
      [/^"O serviço da Saunamo foi excelente, a sauna foi uma compra fantástica, trazendo consigo melhoria da condição cardiovascular, metabolismo acelerado, melhor sono, recovery muscular, eliminação de toxinas, redução do stress\."$/i, "\"Saunamo's service was excellent; the sauna was a fantastic purchase, supporting cardiovascular health, metabolism, sleep, muscle recovery, toxin elimination and stress reduction.\""],
      [/^Refr(?:ig(?:eration|dferation)|idgeration) unit included$/i, 'Cooling unit included'],
      [/^External refr(?:ig(?:eration|dferation)|idgeration) unit included$/i, 'External cooling unit included'],
      [/\bRefr(?:ig(?:eration|dferation)|idgeration)\b/gi, 'Cooling'],
      [/^([0-9]+) itens$/i, '$1 items'],
      [/^Want to plan a complete heating and cooling schedule\?$/i, 'Want to plan a complete hot-and-cold setup?'],
      [/^Planning for (?:cold and heat|heat and cold)$/i, 'Plan a hot-and-cold setup'],
      [/^O uso regular da sauna oferece profundos benefícios para a saúde que vão muito além do relaxamento\. Desde a saúde cardiovascular à recovery muscular, a ciência confirma o que as culturas nórdicas sabem há séculos\.$/i, 'Regular sauna use offers profound health benefits that go far beyond relaxation. From cardiovascular health to muscle recovery, science confirms what Nordic cultures have known for centuries.'],
      [/^O uso regular da sauna oferece profundos benefícios para a saúde que vão muito além do relaxamento\. Desde a saúde cardiovascular à recuperação muscular, a ciência confirma o que as culturas nórdicas sabem há séculos\.$/i, 'Regular sauna use offers profound health benefits that go far beyond relaxation. From cardiovascular health to muscle recovery, science confirms what Nordic cultures have known for centuries.'],
      [/^Quanto tempo demora a sauna exterior a aquecer\?$/i, 'How long does an outdoor sauna take to heat up?'],
      [/^Quanto tempo demora a sauna a aquecer\?$/i, 'How long does the sauna take to heat up?'],
      [/^The Saunamo team can help you choose the right sauna to go with (?:the |your )?(Cube|Ergo|Ofuro), taking into account the available space and how you plan to use the set\.$/i, 'The Saunamo team can help you pair the right sauna with your $1, based on your space and how you want to use it.'],
      [/^Recursos$/i, 'Resources'],
      [/^Contactos$/i, 'Contact'],
      [/^Termina 30 Abr$/i, 'Ends 30 April'],
      [/^Expandir tudo$/i, 'Expand all'],
      [/^Recolher tudo$/i, 'Collapse all'],
      [/^Fechar tudo$/i, 'Collapse all'],
      [/^([0-9]+) modelos$/i, '$1 models'],
      [/\bExpandir tudo\b/gi, 'Expand all'],
      [/\bRecolher tudo\b/gi, 'Collapse all'],
      [/\bFechar tudo\b/gi, 'Collapse all'],
      [/\b([0-9]+) modelos\b/gi, '$1 models'],
      [/^SHOP NOW$/i, 'BUY NOW'],
      [/^Comprar agora — (.+)$/i, 'Buy now — $1'],
      [/^Comprar agora$/i, 'Buy now'],
      [/^Esgotado$/i, 'Sold out'],
      [/^Desde$/i, 'From'],
      [/^3 anos$/i, '3 years'],
      [/^Garantia de 3 Anos$/i, '3-Year Warranty'],
      [/^Garantia de 3 anos$/i, '3-year warranty'],
      [/^Madeira termotatada negra$/i, 'Black thermo-treated wood'],
      [/^Madeira termotatada$/i, 'Thermo-treated wood'],
      [/^Madeira termotratada negra$/i, 'Black thermo-treated wood'],
      [/^Madeira termotratada$/i, 'Thermo-treated wood'],
      [/^Vidro frontal total$/i, 'Full glass front'],
      [/^Desinfecao UV$/i, 'UV disinfection'],
      [/^Desinfe[cç][aã]o UV$/i, 'UV disinfection'],
      [/^Filtra[cç][aã]o de areia$/i, 'Sand filtration'],
      [/^Aquecimento eletrico$/i, 'Electric heating'],
      [/^Aquecimento el[eé]trico$/i, 'Electric heating'],
      [/^Aquecedor a lenha$/i, 'Wood-fired heater'],
      [/^Jatos de [áa]gua potentes$/i, 'Powerful water jets'],
      [/^Forma redonda$/i, 'Round shape'],
      [/^Forma c[uú]bica$/i, 'Cube shape'],
      [/^Forma oval$/i, 'Oval shape'],
      [/^Arrefece a [áa]gua at[eé] 3°C \/ 37°F$/i, 'Cools water to 3°C / 37°F'],
      [/^Aquecimento$/i, 'Heating'],
      [/^Tempo at[eé] aquecer$/i, 'Heat-up time'],
      [/^Materiais e ambiente$/i, 'Materials and environment'],
      [/^Precisa de ajuda a escolher o modelo certo\\?$/i, 'Need help choosing the right model?'],
      [/^Empresa$/i, 'Company'],
      [/^Influenciadores$/i, 'Influencers'],
      [/^Revendedores$/i, 'Dealers'],
      [/^Saunas Personalizadas$/i, 'Custom Saunas'],
      [/^Acess[oó]rios$/i, 'Accessories'],
      [/^Informacoes de contacto$/i, 'Contact information'],
      [/^Informações de contacto$/i, 'Contact information'],
      [/^Segunda a sexta-feira: 9:00 - 18:00$/i, 'Monday to Friday: 9:00 - 18:00'],
      [/^Centenas de clientes felizes (?:na|em toda a) Europa$/i, 'Hundreds of happy customers across Europe'],
      [/^Preencha os seus dados e entramos em contacto em$/i, 'Fill in your details and we will contact you within'],
      [/^menos de 24 horas\\.$/i, '24 hours.'],
      [/^\\* Campos obrigatórios$/i, '* Required fields'],
      [/^seguidores$/i, 'followers'],
      [/^Artigos do Blog$/i, 'Blog Posts'],
      [/^Siga-nos no Instagram$/i, 'Follow us on Instagram'],
      [/^Arrefece a agua ate 3 graus C$/i, 'Cools water to 3 degrees C'],
      [/^Controls manuais$/i, 'Manual controls'],
      [/^Controlos manuais$/i, 'Manual controls'],
      [/^Comandos manuais$/i, 'Manual controls'],
      [/^Painel\s*\+\s*comando remoto$/i, 'Control panel + remote'],
      [/^Painel\s*\+\s*comando à distância$/i, 'Control panel + remote'],
      [/^Painel de controlo\s*\+\s*comando remoto$/i, 'Control panel + remote'],
      [/^Comando remoto$/i, 'Remote control'],
      [/^Comando à distância$/i, 'Remote control'],
      [/^Controlo integrado$/i, 'Built-in control'],
      [/^Controlos integrados$/i, 'Built-in controls'],
      [/^Kit de chaminé vendido separadamente$/i, 'Chimney set separate'],
      [/^A lenha$/i, 'Wood-fired'],
      [/^Disponivel em 9kW and 10\.5kW$/i, 'Available in 9 kW and 10.5 kW'],
      [/^CONTACTAR VENDAS$/i, 'CONTACT SALES'],
      [/^Relaxamento Profundo$/i, 'Deep relaxation'],
      [/^Recuperacao$/i, 'Recovery'],
      [/^Momentos Partilhados$/i, 'Shared moments'],
      [/^Instalacao Simples$/i, 'Simple installation'],
      [/^Saude Cardiovascular$/i, 'Cardiovascular health'],
      [/^Ligacao Social$/i, 'Social connection'],
      [/^Construcao Duravel e Isolada$/i, 'Durable insulated construction'],
      [/^Instalacao Plug and Play$/i, 'Plug-and-play installation'],
      [/^Design Finlandes$/i, 'Finnish design'],
      [/^Orientacao Especializada$/i, 'Expert guidance'],
      [/\btampaing\b/gi, 'covering'],
      [/\brecuperação\b/gi, 'recovery'],
      [/^MODELOS$/i, 'MODELS'],
      [/^COMANDO$/i, 'CONTROL'],
      [/^CONTROLO$/i, 'CONTROL'],
      [/^USO$/i, 'USAGE'],
      [/^ENCAIXE$/i, 'FIT'],
      [/^RESPOSTA$/i, 'RESPONSE'],
      [/^PORQUÊ AAVA$/i, 'WHY AAVA?'],
      [/^PORQUÊ KAJO$/i, 'WHY KAJO?'],
      [/^PORQUÊ TAIKA$/i, 'WHY TAIKA?'],
      [/^PORQUÊ PYROS$/i, 'WHY PYROS?'],
      [/^PORQUÊ NOKI$/i, 'WHY NOKI?'],
      [/^PORQUÊ TULI$/i, 'WHY TULI?'],
      [/^Botões integrados$/i, 'Built-in buttons'],
      [/^Botões integrados no aquecedor$/i, 'Buttons built into the heater'],
      [/^Integrado$/i, 'Integrated'],
      [/^Controlo$/i, 'Control'],
      [/^Tipo de controlo$/i, 'Control type'],
      [/^Controlo do modelo$/i, 'Model control'],
      [/^Antes de encomendar$/i, 'Before ordering'],
      [/^Especificações$/i, 'Specifications'],
      [/^Instalação e suporte$/i, 'Installation and support'],
      [/^Alimentação elétrica$/i, 'Electrical supply'],
      [/^Instalação qualificada$/i, 'Qualified installation'],
      [/^Potência e dados$/i, 'Power and details'],
      [/^Modelos \/ potência$/i, 'Models / power'],
      [/^Ligação elétrica por eletricista certificado$/i, 'Electrical connection by a certified electrician'],
      [/^Preço base · IVA incluído · escolha a potência e confirme o que entra na proposta$/i, 'Base price · VAT included · choose the power rating and confirm what is included in the quote'],
      [/^INCLUI$/i, 'INCLUDED'],
      [/^Chaminé$/i, 'Chimney'],
      [/^Chaminé, when listed on the package$/i, 'Chimney, when listed in the quote'],
      [/^Chaminé, when specified in the proposal$/i, 'Chimney, when listed in the quote'],
      [/^Control settings for the selected model$/i, 'Control configuration for the selected model'],
      [/^Safety guidelines and minimum distances$/i, 'Safety and clearance guidance'],
      [/^Sauna stones, unless otherwise specified in the proposal$/i, 'Sauna stones, unless stated in the quote'],
      [/^Not included in the base price; can be purchased separately:$/i, 'Not included in the base price; can be bought separately:'],
      [/^Modelo \/ potência$/i, 'Model / power'],
      [/\bcaixas\b/gi, 'boxes'],
      [/\bcaixa\b/gi, 'box'],
      [/\bcontrolo\b/gi, 'control'],
      [/\bControlo\b/g, 'Control'],
      [/\balimentação elétrica\b/gi, 'electrical supply'],
      [/\bAlimentação elétrica\b/g, 'Electrical supply'],
      [/\bkg de pedras\b/gi, 'kg of stones'],
      [/\bde pedras\b/gi, 'of stones'],
      [/\bpedras\b/gi, 'stones'],
      [/\bPedras\b/g, 'Stones'],
      [/\blaterais\/traseira\b/gi, 'sides/rear'],
      [/\bLateral\b/g, 'Side'],
      [/\blaterais\b/gi, 'sides'],
      [/\btraseira\b/gi, 'rear'],
      [/\bao teto\b/gi, 'to ceiling'],
      [/\bacima\b/gi, 'above'],
      [/\baltura mínima\b/gi, 'minimum height'],
      [/\bfrente\b/gi, 'front'],
      [/\bporta metálica\b/gi, 'metal door'],
      [/\bporta de vidro\b/gi, 'glass door'],
      [/\bpedras ao teto\b/gi, 'stones to ceiling'],
      [/\bchaminé ao teto\b/gi, 'chimney to ceiling'],
      [/\bisolamento de piso\b/gi, 'floor insulation'],
      [/\baté\b/gi, 'up to'],
      [/\bAté\b/g, 'Up to'],
      [/\bou\b/gi, 'or'],
      [/\bcom\b/gi, 'with'],
      [/^Aquecedor(\s|$)/i, 'Heater$1'],
      [/^Heater a Lenha (.+)$/i, '$1 Wood-Burning Heater'],
      [/^Heater Elétrico (.+)$/i, '$1 Electric Heater'],
      [/^Sauna para ([0-9]+(?:[–-][0-9]+)?) pessoas$/i, 'Fits $1 people'],
      [/\b([0-9]+) pessoas\b/gi, '$1 people'],
      [/\bpessoas\b/gi, 'people'],
      [/\bpessoa\b/gi, 'person'],
      [/\bgarantia\b/gi, 'warranty'],
      [/\banos\b/gi, 'years'],
      [/\bano\b/gi, 'year'],
      [/\bPreço\b/g, 'Price'],
      [/\bpreço\b/g, 'price'],
      [/\bDimensões\b/g, 'Dimensions'],
      [/\bCapacidade\b/g, 'Capacity'],
      [/\bEntrega\b/g, 'Delivery'],
      [/\bInstalação\b/g, 'Installation'],
      [/\bConfiguração\b/g, 'Configuration']
    ];

    rules.forEach(function(rule) {
      var next = translated.replace(rule[0], rule[1]);
      if (next !== translated) {
        translated = next;
        changed = true;
      }
    });

    return changed ? translated : '';
  }

  function applyAll() {
    if (applying || !catalog) return;
    applying = true;
    try {
      document.documentElement.lang = SaunamoForceESViaEN ? 'es' : 'en';
      addBanner();
      addEnglishPolishStyles();
      updateDomainSwitcherForPreview();
      applyProductOverrides();
      fixApprovedSaunaCopy();
      walkAndReplace(document.body);
      applyVisiblePolish(document.body);
      applyEmergencyShopEnglishTextFixes(document.body || document.documentElement);
      replaceAttributes();
      fixCompareExpandControls();
      fixEnglishShopLinks();
      fixUsContactChannels();
      fixQuotePopupEnglishCopy();
      fixResidualEnglishCopy();
      document.documentElement.classList.remove('saunamo-force-en-booting');
    } finally {
      applying = false;
    }
  }

  function addBanner() {
    if (window.SaunamoForceENSilent) {
      document.body.classList.add('saunamo-force-en-active', 'saunamo-force-en-silent');
      return;
    }
    if (document.querySelector('.saunamo-force-en-banner')) return;
    var banner = document.createElement('div');
    banner.className = 'saunamo-force-en-banner';
    banner.innerHTML = '<b>DRAFT EN PREVIEW</b> &nbsp; forced-English mode &nbsp;·&nbsp; theme 199512392019 &nbsp;·&nbsp; add force_en=0 to return to PT';
    document.body.insertBefore(banner, document.body.firstChild);
    document.body.classList.add('saunamo-force-en-active');
  }

  function addEnglishPolishStyles() {
    if (document.getElementById('saunamo-force-en-polish-styles')) return;
    var style = document.createElement('style');
    style.id = 'saunamo-force-en-polish-styles';
    style.textContent = '.icetub-buttons .secondButton{text-transform:none!important;}';
    document.head.appendChild(style);
  var unavailableConfigStyle = document.createElement('style');
  unavailableConfigStyle.textContent = '.saunamo-us-unavailable-config{max-width:760px;margin:0 auto;padding:56px 28px;text-align:center;background:#f3eeea;border-radius:18px}.saunamo-us-unavailable-config__eyebrow{margin:0 0 10px;font-size:12px;letter-spacing:.12em;text-transform:uppercase}.saunamo-us-unavailable-config h2{margin:0 0 14px;font-size:32px;line-height:1.15}.saunamo-us-unavailable-config>p:not(.saunamo-us-unavailable-config__eyebrow){max-width:620px;margin:0 auto 24px;line-height:1.6}.saunamo-us-unavailable-config>div{display:flex;gap:12px;justify-content:center;flex-wrap:wrap}.saunamo-us-unavailable-config a,.saunamo-us-unavailable-config button{display:inline-flex;min-height:48px;align-items:center;justify-content:center;padding:12px 22px;border:1px solid #30353a;border-radius:999px;background:#30353a;color:#fff;text-decoration:none;font:inherit;cursor:pointer}.saunamo-us-unavailable-config button{background:transparent;color:#30353a}@media(max-width:749px){.saunamo-us-unavailable-config{padding:38px 18px}.saunamo-us-unavailable-config h2{font-size:26px}}';
  document.head.appendChild(unavailableConfigStyle);
  }


  // saunamo-us-contact-routing-20260825
  function fixUsContactChannels() {
    var host = (window.location.hostname || '').replace(/^www\./, '');
    if (host !== 'saunamo.us') return;

    document.querySelectorAll('a[href]').forEach(function(link) {
      var href = link.getAttribute('href') || '';
      if (/^(?:mailto:)?info@saunamo\.(?:pt|shop|co\.uk)$/i.test(href)) {
        link.setAttribute('href', 'mailto:info@saunamo.us');
      }
      if (/wa\.me|whatsapp\.com|^whatsapp:/i.test(href)) {
        link.hidden = true;
        link.style.setProperty('display', 'none', 'important');
        var row = link.closest('li');
        if (row) row.style.setProperty('display', 'none', 'important');
      }
    });

    var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentNode && !skipTags[node.parentNode.tagName]) {
        node.nodeValue = node.nodeValue.replace(/info@saunamo\.(?:pt|shop|co\.uk)/gi, 'info@saunamo.us');
      }
    }
  }

  function fixEnglishShopLinks() {
    var host = (window.location.hostname || '').replace(/^www\./, '');
    if (host !== 'saunamo.shop') return;
    document.querySelectorAll('a[href]').forEach(function(link) {
      if (link.closest && link.closest('.saunamo-native-language, .country-selector, .wg-drop, .weglot-container')) return;
      var label = normalise(link.textContent);
      var rawHref = link.getAttribute('href') || '';

      if (/saunamo\.pthttps:\/\/saunamo\.shop/i.test(rawHref)) {
        rawHref = rawHref.replace(/saunamo\.pthttps:\/\/saunamo\.shop/gi, 'saunamo.shop');
        try {
          var shareUrl = new URL(rawHref, window.location.origin);
          if (/pinterest\.com$/i.test(shareUrl.hostname) && /Liquid error/i.test(shareUrl.searchParams.get('media') || '')) {
            shareUrl.searchParams.delete('media');
          }
          link.setAttribute('href', shareUrl.toString());
        } catch (error) {
          link.setAttribute('href', rawHref);
        }
        return;
      }

      if (label === '+351 917 002 672') {
        link.setAttribute('href', 'tel:+351917002672');
        return;
      }
      if (label === 'info@saunamo.shop') {
        link.setAttribute('href', 'mailto:info@saunamo.shop');
        return;
      }
      if (/^https?:\/\/www\.instagram\.pt\/saunamo\.wellness\/?$/i.test(rawHref)) {
        link.setAttribute('href', 'https://www.instagram.com/saunamo.wellness/');
        return;
      }

      var url;
      try {
        url = new URL(rawHref, window.location.origin);
      } catch (error) {
        return;
      }

      var urlHost = (url.hostname || '').replace(/^www\./, '');
      var path = url.pathname.replace(/\/$/, '');
      var internalPtPath = {
        '/pages/sobre-nos': true,
        '/pages/influencers': true,
        '/pages/sauna-manufacturer-b2b': true
      };

      if ((urlHost === 'saunamo.pt' || urlHost === 'saunamo.es') && internalPtPath[path]) {
        url.protocol = window.location.protocol;
        url.hostname = window.location.hostname;
        url.port = window.location.port;
        if (path === '/pages/sobre-nos') url.pathname = '/pages/about-us';
        link.setAttribute('href', url.toString());
        return;
      }

      if (urlHost === 'saunamo.pt' || urlHost === 'saunamo.es') {
        url.protocol = window.location.protocol;
        url.hostname = window.location.hostname;
        url.port = window.location.port;
        link.setAttribute('href', url.toString());
        return;
      }

      if (urlHost === host && path === '/pages/contato') {
        url.pathname = '/pages/contact';
        link.setAttribute('href', url.toString());
      }
    });
  }

  function fixQuotePopupEnglishCopy() {
    var host = (window.location.hostname || '').replace(/^www\./, '');
    if (host !== 'saunamo.shop' && host !== 'saunamo.us') return;
    document.querySelectorAll('#indentPopupOverlay [data-t="step1_sub"], .indent-popup-overlay [data-t="step1_sub"]').forEach(function(element) {
      var text = normalise(element.textContent);
      if (/Fill in your details and we'll be in touch within less than 24 hours\./i.test(text) ||
          /Fill in your details and we'll get back to you within 24 hours\./i.test(text) ||
          /Preencha os seus dados e entraremos em contacto em menos de\s+24 horas/i.test(text)) {
        element.innerHTML = "Fill in your details and we'll get back to you within <strong>24 hours</strong>.";
      }
    });
    document.querySelectorAll('#indentPopupOverlay .snm-title, .indent-popup-overlay .snm-title').forEach(function(element) {
      if (normalise(element.textContent) === 'A few moredetails') {
        element.textContent = 'A few more details';
      }
    });
    document.querySelectorAll('#indentPopupOverlay .snm-testi-quote, .indent-popup-overlay .snm-testi-quote').forEach(function(element) {
      if (/^"O serviço da Saunamo foi excelente/i.test(normalise(element.textContent))) {
        element.textContent = "\"Saunamo's service was excellent; the sauna was a fantastic purchase, supporting cardiovascular health, metabolism, sleep, muscle recovery, toxin elimination and stress reduction.\"";
      }
    });
  }

  function fixResidualEnglishCopy() {
    var host = (window.location.hostname || '').replace(/^www\./, '');
    if (host !== 'saunamo.shop' && host !== 'saunamo.us') return;
    var exact = {
      'Recursos': 'Resources',
      'Contactos': 'Contact',
      'Aquecedor Wood-fired': 'Wood-fired heater',
      'Fabricação Europeia': 'European manufacturing',
      'Entrega Mundial e Suporte Dedicado': 'Worldwide delivery and dedicated support',
      'EXPLORAR A NOSSA GAMA': 'EXPLORE OUR RANGE',
      'Instalação de uma Sauna Exterior': 'Outdoor Sauna Installation',
      'VER VÍDEO COMPLETO AQUI': 'WATCH THE FULL VIDEO HERE',
      'Ver vídeo completo aqui': 'WATCH THE FULL VIDEO HERE',
      'Sauna Exterior': 'Outdoor Sauna',
      'Confiada por Empresas': 'Trusted by Businesses',
      'Confiada por Companys': 'Trusted by Businesses',
      'CONTACTE OS ESPECIALISTAS': 'CONTACT OUR SPECIALISTS',
      'Contacte os especialistas': 'Contact our specialists',
      'Instalação e Fundações': 'Installation and foundations',
      'Instalacao Plug and Play': 'Plug-and-play installation',
      'Utilização exterior': 'Outdoor use',
      'Concebida': 'Designed',
      'Fale com os nossos especialistas em aquecedores!': 'Talk to our heater specialists!',
      'Talk to our specialists em aquecedores!': 'Talk to our heater specialists!',
      'Controls manuais': 'Manual controls',
      'Fale with os nossos especialistas': 'Talk to our specialists',
      'Fale with a equipa': 'Talk to the team',
      'FALE WITH A EQUIPA': 'TALK TO THE TEAM',
      'Porque Comprar uma Sauna Exterior na Saunamo?': 'Why buy an outdoor sauna from Saunamo?',
      'Porque Comprar uma Banheira de Hidromassagem na Saunamo?': 'Why buy a hot tub from Saunamo?',
      '1 pessoa': '1 person',
      '2 pessoas': '2 people',
      '3 pessoas': '3 people',
      '4 pessoas': '4 people',
      '5 pessoas': '5 people',
      '6 pessoas': '6 people',
      '8 pessoas': '8 people',
      'Amieiro': 'Alder',
      'Aquecedor de 4.7 kW': '4.7 kW heater',
      'Aquecedor de 6 kW': '6 kW heater',
      'Aquecedor de 6.6 kW': '6.6 kW heater'
    };
    var regexRules = [
      [/^Entre no processo de instalação e veja como a nossa equipa transforma matérias-primas numa sauna completamente acabada.*$/i, 'Step inside the installation process and see how our team turns raw materials into a finished sauna, made with precision, Finnish expertise and close attention to detail.'],
      [/^Fabricação europeia, construída para durar, com confiança em todo o mundo\.$/i, 'European manufacturing, built to last and trusted worldwide.'],
      [/^Fabricada na UE com materiais de alta qualidade.*$/i, 'Made in the EU with high-quality materials, precise craftsmanship and timeless aesthetics.'],
      [/^Concebidos com os autênticos princípios finlandeses.*$/i, 'Designed around authentic Finnish sauna principles: proper airflow, correct heat distribution, premium woods and the complete heat-cold-rest ritual.'],
      [/^Materiais selecionados especificamente para ambientes extremos.*$/i, 'Materials selected specifically for demanding conditions: intense heat, humidity, cold exposure, vibration and long-term durability in outdoor installations.'],
      [/^Instaladores, eletricistas e carpinteiros especializados.*$/i, 'Specialist installers, electricians and carpenters make sure every sauna, spa and cold plunge is installed correctly and safely, with no improvisation and no shortcuts.'],
      [/^Instaladores, eletricistas e carpinteiros certificados garantem que cada sauna interior.*$/i, 'Certified installers, electricians and carpenters make sure every indoor sauna is installed correctly and safely.'],
      [/^Instaladores, eletricistas e carpinteiros certificados garantem que cada produto.*$/i, 'Certified installers, electricians and carpenters make sure every product is installed correctly and safely.'],
      [/^Todas as saunas de exterior da Saunamo incluem.*$/i, 'All Saunamo outdoor saunas include a 3-year warranty covering manufacturing and workmanship defects for long-term peace of mind.'],
      [/^O banho de gelo e amplamente utilizado.*$/i, 'Ice baths are widely used to help manage inflammation after intense activity and support healthier balance.'],
      [/^Fornecemos orientacoes claras.*$/i, 'We provide clear guidance for your electrician and recommend suitable ventilation for ideal performance and safety.'],
      [/^Oferecemos um ecossistema de bem-estar de inspiração finlandesa:.*$/i, 'We offer a Finnish-inspired wellness ecosystem: saunas, cold plunges and hot tubs. One brand, one experience, one trusted partner.'],
      [/^Obrigado à Saunamo pela sauna\..*$/i, 'Thank you to Saunamo for the sauna. From the many sauna options presented by the company, I chose the one that best fit my needs. The sauna was manufactured and delivered on time. There was a setback with the required wood-fired heater delivery, but Saunamo resolved that too. The company employs experienced Finnish specialists who understand sauna culture deeply. Keep going!'],
      [/^A Saunamo construiu uma sauna para nós.*$/i, 'Saunamo built a sauna for us last winter and what can I say: we were surprised by the quality, customer service, design and functionality. It was not an easy job because we live in a very remote location, but they were not put off and made it happen. We use the sauna frequently, 3-4 times per week, and we are absolutely satisfied. Last summer the wood moved slightly due to temperature changes and a small gap appeared. Saunamo solved it immediately, which is quite rare in customer service today. Communication was always fast and reliable and questions were solved right away. So if you want a sauna, choose this team!'],
      [/^Quer comprar uma sauna interior para a sua casa\?.*$/i, 'Looking to buy an indoor sauna for your home? Saunamo offers a selected collection of premium indoor saunas designed for private bathrooms, home gyms, wellness rooms and refined interiors. Rooted in Finnish sauna culture, each sauna is built with sauna-grade, non-toxic materials chosen for stability, comfort and timeless design.'],
      [/^Quer comprar uma sauna exterior para o seu jardim ou terraco\?.*$/i, 'Looking to buy an outdoor sauna for your garden or terrace? Saunamo offers a selected collection of premium outdoor saunas built from weather-resistant thermo-treated wood and designed to last outdoors for decades.'],
      [/^Concebidas para quem compreende o poder do frio,.*$/i, 'Designed for people who understand the power of cold, Saunamo ice baths offer a refined approach to cold-water therapy. Built with durable materials and high-performance cooling systems, they are ideal for regular home, wellness and professional use.'],
      [/^O aquecedor e o coracao da sauna\..*$/i, 'The heater is the heart of the sauna. Whether wood-fired or electric, the right heater should deliver balanced heat, durability and an authentic experience. Saunamo offers a selected range of high-quality sauna heaters.'],
      [/^A Saunamo tem anos de experiencia na concepcao.*$/i, 'Saunamo has years of experience designing and building wellness spaces for private and professional clients across Europe. Our team is available to help you find the right solution.'],
      [/^O nosso showroom esta localizado na sede da Saunamo.*$/i, 'Our showroom is located at Saunamo headquarters in Ourem, Portugal, where you can experience our wellness solutions in a calm, carefully designed setting. Explore materials, finishes and layouts in person.'],
      [/^Concebida para até seis pessoas,.*$/i, 'Designed for up to six people, the Cube 200 balances shared moments with individual relaxation. Wood-fired heating gives the experience a more authentic ritual feel, with optional electric support for added convenience.'],
      [/^Com a sua forma cilíndrica e acabamento em madeira,.*$/i, 'With its cylindrical shape and wood finish, the Ergo brings a natural, understated presence to any outdoor space. Designed for a regular cold-water ritual, it offers a simple way to wake the body, recover energy and build a steady routine.'],
      [/^Quanto tempo demora a sauna a aquecer\?$/i, 'How long does the sauna take to heat up?'],
      [/^Quanto tempo demora a sauna exterior a aquecer\?$/i, 'How long does an outdoor sauna take to heat up?'],
      [/^Fale with os nossos especialistas$/i, 'Talk to our specialists'],
      [/^Fale com os nossos especialistas em aquecedores!$/i, 'Talk to our heater specialists!'],
      [/^Talk to our specialists em aquecedores!$/i, 'Talk to our heater specialists!'],
      [/^Fale with a equipa$/i, 'Talk to the team'],
      [/^FALE WITH A EQUIPA$/i, 'TALK TO THE TEAM'],
      [/^Fale with (.+)$/i, 'Talk to $1'],
      [/^Concebida para utiliza[cç][aã]o exterior$/i, 'Designed for outdoor use'],
      [/^Concebida para Viver em Interiores$/i, 'Designed for indoor living'],
      [/^Fale com a equipa$/i, 'Talk to our team'],
      [/^FALE COM A EQUIPA$/i, 'TALK TO OUR TEAM'],
      [/^Fale com um especialista$/i, 'Talk to a specialist'],
      [/^FALE COM UM ESPECIALISTA$/i, 'TALK TO A SPECIALIST'],
      [/^For Indoor and Utiliza[cç][aã]o exterior$/i, 'For Indoor and Outdoor Use'],
      [/^Para utiliza[cç][aã]o interior e exterior$/i, 'For Indoor and Outdoor Use']
    ];
    function replacementFor(value) {
      var key = normalise(value);
      if (exact[key]) return exact[key];
      for (var i = 0; i < regexRules.length; i += 1) {
        if (regexRules[i][0].test(key)) return key.replace(regexRules[i][0], regexRules[i][1]);
      }
      return '';
    }
    document.querySelectorAll('a, button, span, p, h1, h2, h3, h4, h5, h6, li, label, summary, div').forEach(function(element) {
      if (element.closest && element.closest('#dyn-configurador, [data-saunamo-force-en-skip="true"], .saunamo-force-en-banner')) return;
      if (element.children.length > 0) return;
      var next = replacementFor(element.textContent || '');
      if (next) element.textContent = next;
    });
    var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        return replacementFor(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function(textNode) {
      var original = textNode.nodeValue || '';
      var next = replacementFor(original);
      if (!next) return;
      var leading = (original.match(/^\s*/) || [''])[0];
      var trailing = (original.match(/\s*$/) || [''])[0];
      textNode.nodeValue = leading + next + trailing;
    });
    document.querySelectorAll('[alt], [title], [placeholder], [aria-label], [value]').forEach(function(element) {
      ['alt', 'title', 'placeholder', 'aria-label', 'value'].forEach(function(attribute) {
        var current = element.getAttribute(attribute);
        var next = replacementFor(current);
        if (!next) return;
        element.setAttribute(attribute, next);
        if (attribute === 'value' && 'value' in element) element.value = next;
      });
    });
  }

  function updateDomainSwitcherForPreview() {
    document.querySelectorAll('.saunamo-native-language').forEach(function(switcher) {
      var buttonFlagNew = switcher.querySelector('.saunamo-native-language__button .saunamo-native-language__flag');
      var buttonFlagOld = switcher.querySelector('.saunamo-native-language__button .countryflags');
      var code = switcher.querySelector('.saunamo-native-language__code');
      var flagEmojiSupported = (function() {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = 32;
          canvas.height = 24;
          var ctx = canvas.getContext('2d');
          if (!ctx) return true;
          ctx.font = '18px Arial, sans-serif';
          ctx.fillText('🇬🇧', 2, 18);
          var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
          var coloredPixels = 0;
          for (var i = 0; i < data.length; i += 4) {
            if (data[i + 3] < 20) continue;
            var max = Math.max(data[i], data[i + 1], data[i + 2]);
            var min = Math.min(data[i], data[i + 1], data[i + 2]);
            if (max - min > 50) coloredPixels += 1;
          }
          return coloredPixels > 12;
        } catch (e) {
          return true;
        }
      })();
      function setGbFlag(flag) {
        if (!flag) return;
        flag.setAttribute('data-iso', 'en');
        flag.setAttribute('data-flag', 'GB');
        Array.prototype.slice.call(flag.classList).forEach(function(className) {
          if (/^countryflag__/.test(className)) flag.classList.remove(className);
        });
        if (flagEmojiSupported) {
          flag.textContent = '🇬🇧';
          flag.classList.remove('countryflags');
        } else {
          flag.textContent = '';
          flag.classList.add('countryflags');
          flag.classList.add('countryflag__GB');
        }
      }
      if (buttonFlagNew) {
        setGbFlag(buttonFlagNew);
      } else if (buttonFlagOld) {
        setGbFlag(buttonFlagOld);
      }
      if (code) code.textContent = 'EN';
      switcher.querySelectorAll('.saunamo-native-language__link').forEach(function(link) {
        var isEnglish = (link.getAttribute('hreflang') || '').toLowerCase() === 'en';
        link.classList.toggle('is-active', isEnglish);
        if (isEnglish) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    });
  }

  function currentProduct() {
    if (!catalog) return null;
    var handle = window.SaunamoForceENProductHandle || '';
    return (catalog.products || {})[handle] || null;
  }

  function applyProductOverrides() {
    var product = currentProduct();
    if (!product) return;

    if (product.title) {
      document.querySelectorAll([
        '[data-saunamo-product-field="title"]',
        '.product-information__title',
        '.product__title',
        '.product-title',
        '.main-product__title',
        '.sm-cube220-buybar__name',
        '.sm-wellness-topfold__title'
      ].join(',')).forEach(function(element) {
        if (element && normalise(element.textContent)) {
          element.textContent = product.title;
        }
      });

      var firstHeading = document.querySelector('main h1, h1');
      if (firstHeading && normalise(firstHeading.textContent)) {
        firstHeading.textContent = product.title;
      }
    }

    if (product.meta_title) {
      document.title = product.meta_title;
    } else if (product.title) {
      document.title = product.title + ' | Saunamo';
    }

    if (product.meta_description) {
      var metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) metaDescription.setAttribute('content', product.meta_description);
    }

    if (product.body_html) {
      document.querySelectorAll([
        '[data-saunamo-product-field="body_html"]',
        '.product-information__description',
        '.product__description',
        '.product-description',
        '.rte.product__description'
      ].join(',')).forEach(function(element) {
        if (element) element.innerHTML = product.body_html;
      });
    }
  }

  function shouldSkip(node) {
    var parent = node && node.parentNode;
    if (!parent || !parent.tagName) return true;
    if (skipTags[parent.tagName]) return true;
    if (parent.closest && parent.closest('#dyn-configurador, [data-saunamo-force-en-skip="true"], .saunamo-force-en-banner')) return true;
    return false;
  }

  function walkAndReplace(root) {
    if (!root || !common) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        if (!normalise(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function(textNode) {
      var original = textNode.nodeValue || '';
      var translated = lookup(original);
      if (!translated) return;
      var leading = (original.match(/^\s*/) || [''])[0];
      var trailing = (original.match(/\s*$/) || [''])[0];
      textNode.nodeValue = leading + translated + trailing;
    });

    replaceWholeElementText(root);
  }

  function replaceWholeElementText(root) {
    root.querySelectorAll('button, a, span, p, h1, h2, h3, h4, h5, h6, li, summary, label, th, td').forEach(function(element) {
      if (element.closest && element.closest('#dyn-configurador, [data-saunamo-force-en-skip="true"], .saunamo-force-en-banner')) return;
      if (element.children.length > 0) return;
      var original = element.textContent || '';
      var translated = lookup(original);
      if (translated) element.textContent = translated;
    });
  }

  function replaceAttributes() {
    document.querySelectorAll('[alt], [title], [placeholder], [aria-label]').forEach(function(element) {
      if (element.closest && element.closest('#dyn-configurador, [data-saunamo-force-en-skip="true"]')) return;
      ['alt', 'title', 'placeholder', 'aria-label'].forEach(function(attribute) {
        var value = element.getAttribute(attribute);
        var translated = lookup(value);
        if (translated) element.setAttribute(attribute, translated);
      });
    });
  }

  function fixCompareExpandControls() {
    document.querySelectorAll('[data-compare-expand-all]').forEach(function(button) {
      var translated = lookup(button.textContent || '');
      if (translated) button.textContent = translated;
      if (button.dataset.saunamoForceEnCompareBound === 'true') return;
      button.dataset.saunamoForceEnCompareBound = 'true';
      button.addEventListener('click', function() {
        [0, 50, 150, 400].forEach(function(delay) {
          window.setTimeout(function() {
            var next = lookup(button.textContent || '');
            if (next) button.textContent = next;
          }, delay);
        });
      });
    });
  }

  function watchChanges() {
    document.addEventListener('shopify:section:load', function() {
      window.setTimeout(applyAll, 50);
    });

    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function() {
      if (applying) return;
      window.clearTimeout(observer._saunamoTimer);
      observer._saunamoTimer = window.setTimeout(applyAll, 120);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    // Belt-and-braces: late-rendering carousels (.phs-card, swipers) can
    // populate after our initial walks. Force three more full applyAll
    // passes at 1.5s / 4s / 8s so static text inside late-injected DOM
    // gets rewritten. Each pass respects the `applying` guard.
    [1500, 4000, 8000, 14000].forEach(function(ms){
      window.setTimeout(function(){ if (catalog) applyAll(); }, ms);
    });
  }
})();

/* Saunamo US market corrections 2026-08-18. Isolated by hostname. */
(function () {
  'use strict';
  if (window.location.hostname.toLowerCase() !== 'saunamo.us') return;
  if (window.__saunamoUsCorrections1787559900) return;
  window.__saunamoUsCorrections1787559900 = true;

  var BARREL_COLLECTION_IMAGE = 'https://saunamo.us/cdn/shop/files/sauna-exterior-barril-160-8373343.png?v=1781167220&width=1500';
  var INDOOR_COLLECTION_IMAGE = 'https://cdn.shopify.com/s/files/1/0714/8562/0513/collections/saunamo-indoor-sauna-20260831.png?v=1788178139';
  var INFRARED_COLLECTION_IMAGE = 'https://cdn.shopify.com/s/files/1/0714/8562/0513/files/sauna-infravermelho-aura-110-1477056.png?v=1785310214';
  var ICE_BATHS_COLLECTION_IMAGE = 'https://cdn.shopify.com/s/files/1/0714/8562/0513/collections/ice-baths-6294217.png?v=1771364665';
  var HARVIA_COLLECTION_IMAGE = 'https://cdn.shopify.com/s/files/1/0714/8562/0513/t/113/assets/saunamo-harvia-heaters-user-selected-v2-20260901.png?v=1788255788';
  var ACCESSORIES_COLLECTION_IMAGE = 'https://cdn.shopify.com/s/files/1/0714/8562/0513/t/113/assets/saunamo-accessories-lifestyle-v2-20260831.png?v=1788250316';
  var hiddenPaths = [
    '/collections/sauna-heaters',
    '/collections/aquecedores',
    '/collections/aquecedores-de-sauna',
    '/collections/spas',
    '/collections/hot-tubs',
    '/collections/outlet',
    '/pages/saunas-personalizadas',
    '/pages/custom-sauna',
    '/pages/custom-saunas'
  ];
  var forbiddenOutdoorHandles = [
    '/products/outdoor-sauna-cube-',
    '/products/outdoor-sauna-hiki-'
  ];
  var exactCopy = {
    'Manufacturer of Saunas, Hot Tubs and Ice Baths': 'Manufacturer of Saunas',
    'Whether you are creating a private wellness space at home or a professional installation for your business, Saunamo designs and manufactures saunas, ice baths and hot tubs for long-term performance.': 'Whether you are creating a private wellness space at home or a professional installation for your business, Saunamo designs and manufactures saunas for long-term performance.',
    'We offer a Finnish-inspired wellness ecosystem: saunas, cold plunges and hot tubs. One brand, one experience, one trusted partner.': 'We offer Finnish-inspired saunas for homes and businesses. One brand, one experience, one trusted partner.',
    'Início': 'Home',
    'BANHEIRAS DE GELO': 'ICE BATHS',
    'Banheiras de Gelo': 'Ice Baths',
    'Recursos': 'Resources',
    'Contactos': 'Contact',
    'Empresa': 'Company',
    'Influenciadores': 'Influencers',
    'Revendedores': 'Dealers',
    'O Que Oferecemos aos Nossos Revendedores': 'What We Offer Our Resellers',
    'O Que Oferecemos aos Nossos Dealers': 'What We Offer Our Resellers',
    'Saunas Por Medida': 'Custom Saunas',
    'Acessórios': 'Accessories',
    'EXPLORE A NOSSA GAMA': 'EXPLORE OUR RANGE',
    'COMPRAR AGORA': 'SHOP NOW',
    'Comprar agora': 'Shop now',
    'Desde': 'From',
    'Orçamento': 'Quote',
    'Pedir orçamento': 'Request a quote',
    'Peça o seu orçamento grátis': 'Request your free quote',
    'Transporte': 'Delivery',
    'Prazo de entrega': 'Delivery time',
    'Descrição': 'Description',
    'Características': 'Features',
    'Especificações': 'Specifications',
    'Materiais': 'Materials',
    'Dimensões': 'Dimensions',
    'Capacidade': 'Capacity',
    'pessoas': 'people',
    'pessoa': 'person',
    'Até': 'Up to',
    '14 models': '9 models',
    'Professional assembly available and coordinated by Saunamo.': 'On-site assembly is not provided by Saunamo in the United States.',
    'Optional professional assembly': 'DIY assembly instructions included',
    'Assembly and electrical installation available as add-ons': 'DIY assembly guidance and detailed instructions are provided',
    'VAT incl. · assembly included · delivery by region': 'USD pricing · delivery selected in the configurator · on-site assembly not included',
    'VAT incl. · sauna only': 'USD base price · heater and options selected separately',
    'Base price · VAT included · Heater and extras configurable below': 'Base price in USD · heater, delivery and options are selected separately below',
    'Heater included — electric or wood-burning, your choice': 'Choose a matched Harvia heater in the configurator',
    'Accessory set': 'Sauna accessory set (optional)',
    'Heater and stones': 'Heater and stones selected separately in the configurator',
    'Lighting': 'Lighting',
    'Accessory kit': 'Accessory kit (optional)',
    'Transport and crane placement': 'Delivery is selected separately; unloading and placement are arranged locally',
    'Final on-site electrical connection': 'Final electrical connection is arranged locally by the customer',
    'Acabamentos e Ambiente': 'Finishes & Atmosphere',
    'Stress Relief market': 'Stress Relief',
    'Specialist Installation Network': 'Flexible Local Installation',
    'Certified installers, electricians and carpenters ensure every indoor sauna is installed correctly and safely.': 'Use the supplied instructions for DIY assembly, or work with a qualified local handyman, contractor and electrician as required.',
    'Saunamo has years of experience building standard and custom-sized indoor saunas across Europe. Our indoor saunas are made with premium materials and designed to integrate seamlessly into any indoor space.': 'Saunamo has years of experience building premium indoor saunas for homes and wellness spaces. We help you choose the right model and prepare for delivery to the United States.',
    'Um especialista Saunamo analisa o seu espaço, as suas preferências e o orçamento, e recomenda o modelo ideal em minutos.': 'A Saunamo specialist reviews your space, preferences and budget, then recommends the right model in just a few minutes.',
    'O nosso especialista em saunas analisa o seu espaço, preferências e orçamento, e recomenda o modelo ideal em poucos minutos.': 'Our sauna specialist reviews your space, preferences and budget, then recommends the right model in just a few minutes.',
    'Ideal para rotinas de recovery por infravermelhos para uma person with instalação interior simples.': 'Ideal for one-person infrared recovery routines with straightforward indoor installation.',
    'Ideal para sessões de infravermelhos para duas people or uma rotina de recovery individual mais espaçosa.': 'Ideal for two-person infrared sessions or a more spacious individual recovery routine.',
    '4.7 kW Heater': 'Harvia 4.5 kW heater',
    'Requires 3.5 kW heater': 'Harvia 4.5 kW heater',
    'Requires 6 kW heater': 'Harvia 6 kW heater',
    'Requires 9 kW heater': 'Harvia 8–9 kW heater',
    '4.7–6.6 kW Heater': 'Harvia 6–7 kW heater',
    '9–10.5 kW Heater': 'Harvia 8–11 kW heater',
    'We review the room, measurements and access with you before ordering. Aura only needs a level floor, suitable ventilation and a standard 230 V socket near the installation point.': 'We review the room, measurements and access with you before ordering. Aura needs a level floor, suitable ventilation and a suitable local power supply. Final electrical connection must be completed by a qualified local electrician.',
    'Standard 230 V socket': 'Local electrical connection',
    'Assembly takes 1-2 hours and can be done by one person — the modules fit together without special tools. If you prefer, the Saunamo team can also provide professional assembly. Connection is plug-and-play: just plug it into a 230 V socket. No electrician, no building work.': 'The modules fit together without special tools, typically in 1–2 hours. Saunamo provides clear instructions, so you can assemble it yourself or ask a local handyman or contractor to help. Any electrical work must be completed by a qualified local electrician.',
    'Assembly takes 1–2 hours and can be done by one person — the modules fit together without special tools. If you prefer, the Saunamo team can also provide professional assembly. Connection is plug-and-play: just plug it into a 230 V socket. No electrician, no building work.': 'The modules fit together without special tools, typically in 1–2 hours. Saunamo provides clear instructions, so you can assemble it yourself or ask a local handyman or contractor to help. Any electrical work must be completed by a qualified local electrician.',
    'Assembly takes about 3–5 hours and is designed for 2 people using common tools. If you prefer, Saunamo also offers professional assembly. Aura uses a single-phase 230 V connection; confirm that the socket and final connection are suitable for the location before installation.': 'Assembly takes about 3–5 hours and is designed for 2 people using common tools. Saunamo provides clear instructions, so you can assemble it yourself or ask a local handyman or contractor to help. Any electrical work must be completed by a qualified local electrician.',
    'You can assemble the Aisti yourself — we provide detailed manuals with step-by-step instructions. If you prefer, you can add Saunamo professional assembly, where our team takes care of everything. For the electrical connection, you can use your own electrician or add Saunamo’s electrical installation service.': 'You can assemble the Aisti yourself using the supplied step-by-step instructions, or ask a local handyman or contractor to help. Any electrical connection must be completed by a qualified local electrician. We send the electrical diagram for the model.',
    'You can assemble the Aisti yourself — we provide detailed manuals with step-by-step instructions. If you prefer, you can add Saunamo professional assembly, where our team takes care of everything. For the electrical connection, you can use your own electrician or add Saunamo\'s electrical installation service.': 'You can assemble the Aisti yourself using the supplied step-by-step instructions, or ask a local handyman or contractor to help. Any electrical connection must be completed by a qualified local electrician. We send the electrical diagram for the model.',
    'You can assemble the Thermo Black yourself — we provide detailed manuals with step-by-step instructions. If you prefer, you can add Saunamo professional assembly, where our team takes care of everything. For the electrical connection, you can use your own electrician or add Saunamo’s electrical installation service.': 'You can assemble the Thermo Black yourself using the supplied step-by-step instructions, or ask a local handyman or contractor to help. Any electrical connection must be completed by a qualified local electrician. We send the electrical diagram for the model.',
    'You can assemble the sauna with your team or choose professional assembly coordinated by Saunamo. The heater connection must be completed by a certified electrician. We always send the electrical diagram and technical requirements for the model.': 'On-site assembly is not included in the United States. The sauna is supplied with clear instructions, so you can assemble it yourself or ask a local handyman or contractor to help. The heater connection must be completed by a qualified local electrician. We always send the electrical diagram and technical requirements for the model.',
    'The sauna can be assembled by two people or with professional assembly coordinated by Saunamo. The electrical connection must be completed by a certified electrician. We always send the electrical diagram and model requirements.': 'The sauna can be assembled by two people using the supplied instructions, or with a local handyman or contractor. The electrical connection must be completed by a qualified local electrician. We always send the electrical diagram and model requirements.',
    'We help validate the space, heater and delivery — and handle everything from setup to assembly.': 'We help you validate the space, heater and delivery. On-site assembly is not included in the United States; Saunamo provides the instructions.',
    'The sauna is supplied with assembly documentation and can be installed by you or by a local team. If you prefer, Saunamo can help coordinate professional assembly where available.': 'The sauna is supplied with assembly documentation, so you can assemble it yourself or ask a local handyman or contractor to help. On-site assembly is not included in the United States.',
    'Yes. The models are supplied for on-site assembly with clear visual instructions. If you prefer, we can also help coordinate professional assembly.': 'Yes. The models are supplied for on-site assembly with clear visual instructions, so you can assemble it yourself or ask a local handyman or contractor to help. On-site assembly is not included in the United States.',
    'Yes. Aura 220 includes assembly documentation and is designed for two people using common tools. Allow approximately 3–5 hours. If you prefer, we can also coordinate professional assembly.': 'Yes. Aura 220 includes assembly documentation and is designed for two people using common tools. Allow approximately 3–5 hours. Any electrical work must be completed by a qualified local electrician.',
    'O seu carrinho está vazio, mas podemos ajudá-lo a preenchê-lo com produtos incríveis.': 'Your cart is empty, but we can help you fill it with something worthwhile.',
    // saunamo-us-visible-english-20260825
    'Volume da sauna': 'Sauna volume',
    'Tempo de aquecimento': 'Heating time',
    'INFRA COMPACTA': 'COMPACT INFRARED',
    'INFRA CONFORTO': 'SPACIOUS INFRARED',
    'THERMO COMPACTA': 'COMPACT THERMO',
    'THERMO CONFORTO': 'SPACIOUS THERMO',
    'Need help choosing the right model??': 'Need help choosing the right model?',
    'Ideal para sessões tradicionais de sauna individual em espaços interiores compactos.': 'Ideal for traditional solo sauna sessions in compact indoor spaces.',
    'Ideal para casais ou uso individual confortável em casas de banho, ginásios e salas de bem-estar.': 'Ideal for couples or comfortable solo use in bathrooms, gyms and wellness rooms.',
    'Ideal para rotinas de recuperação por infravermelhos para uma pessoa com instalação interior simples.': 'Ideal for one-person infrared recovery routines with straightforward indoor installation.',
    'Ideal para sessões de infravermelhos para duas pessoas ou uma rotina de recuperação individual mais espaçosa.': 'Ideal for two-person infrared sessions or a more spacious individual recovery routine.',
    'Ideal para interiores compactos onde a sauna precisa de um acabamento arquitetónico mais escuro.': 'Ideal for compact interiors where the sauna needs a darker architectural finish.',
    'Ideal para sessões tradicionais de sauna para duas pessoas com um acabamento escuro refinado.': 'Ideal for traditional two-person sauna sessions with a refined dark finish.',
    'Ideal para salas de bem-estar interiores maiores onde o calor tradicional partilhado importa.': 'Ideal for larger indoor wellness rooms where shared traditional heat matters.',
    'Ideal para sessões de sauna interior sociais e layouts mais amplos e confortáveis.': 'Ideal for social indoor sauna sessions and larger, more comfortable layouts.',
    'Ideal para sessões tradicionais de sauna individual em espaços interiores compactos.': 'Ideal for traditional solo sauna sessions in compact indoor spaces.',
    'Ideal para casais or uso individual confortável em casas de banho, ginásios e salas de bem-estar.': 'Ideal for couples or comfortable solo use in bathrooms, gyms and wellness rooms.',
    'Ideal para interiores compactos onde a sauna precisa de um acabamento arquitetónico mais escuro.': 'Ideal for compact interiors where the sauna needs a darker architectural finish.',
    'Ideal para sessões tradicionais de sauna para duas people with um acabamento escuro refinado.': 'Ideal for traditional two-person sauna sessions with a refined dark finish.',
    'Ideal para salas de bem-estar interiores maiores onde o calor tradicional partilhado importa.': 'Ideal for larger indoor wellness rooms where shared traditional heat matters.',
    'Ideal para sessões de sauna interior sociais e layouts mais amplos e confortáveis.': 'Ideal for social indoor sauna sessions and larger, more comfortable layouts.',
    // saunamo-us-visible-english-v2-20260825
    'Infra compacta': 'Compact infrared',
    'Infra conforto': 'Spacious infrared',
    'Thermo compacta': 'Compact thermo',
    'Thermo conforto': 'Spacious thermo',
    'Ideal para rotinas de recovery por infravermelhos para uma person with Installation interior simples.': 'Ideal for one-person infrared recovery routines with straightforward indoor installation.',

  };
  var phraseCopy = [
    [/\b([0-9]+) people people\b/gi, '$1 people'],
    [/Até/gi, 'Up to'],
    [/O Que Oferecemos aos Nossos (?:Revendedores|Dealers)/gi, 'What We Offer Our Resellers'],
    [/Saunas Exteriores/gi, 'Outdoor Saunas'],
    [/Saunas Interiores/gi, 'Indoor Saunas'],
    [/Aquecedores de Sauna/gi, 'Sauna Heaters'],
    [/Adicionar ao carrinho/gi, 'Add to cart'],
    [/Envio calculado no checkout/gi, 'Shipping calculated at checkout'],
    [/Impostos incluídos/gi, 'Taxes included'],
    [/Solicitar orçamento/gi, 'Request a quote'],
    [/Fale com os nossos especialistas/gi, 'Talk to our specialists'],
    [/\d+(?:[.,]\d+)?\s*kW electric or wood-burning heater\s*\([^)]*(?:Pyros|Tuli|Kylo|Kilo|Kajo|Taika|Fortis)[^)]*\)/gi, 'Harvia electric or wood-burning heater selected in the configurator'],
    [/Heater\s+[0-9.,–—-]+\s*kW\s*\/\s*wood-burning\s+(?:Pyros|Tuli|Kylo|Kilo|Kajo|Taika|Fortis)/gi, 'Harvia heater matched to sauna size'],
    [/wood-burning\s+(?:Pyros|Tuli|Kylo|Kilo|Kajo|Taika|Fortis)/gi, 'Harvia wood-burning heater'],
    [/(?:Pyros|Tuli|Kylo|Kilo|Kajo|Taika|Fortis)\s*[0-9.,]*\s*kW/gi, 'Harvia heater'],
    [/If you prefer, the Saunamo team can also provide professional assembly\./gi, ''],
    [/If you prefer, Saunamo also offers professional assembly\./gi, ''],
    [/If you prefer, you can add Saunamo professional assembly, where our team takes care of everything\./gi, ''],
    [/If you prefer, Saunamo can help coordinate professional assembly where available\./gi, ''],
    [/If you prefer, we can also help coordinate professional assembly\./gi, ''],
    [/If you prefer, we can also coordinate professional assembly\./gi, ''],
    [/or choose professional assembly coordinated by Saunamo/gi, 'or ask a local handyman or contractor to help'],
    [/or with professional assembly coordinated by Saunamo/gi, 'or with a local handyman or contractor'],
    [/For the electrical connection, you can use your own electrician or add Saunamo[’']s electrical installation service\./gi, 'Any electrical connection must be completed by a qualified local electrician.'],
    [/Connection is plug-and-play: just plug it into a 230 V socket\. No electrician, no building work\./gi, 'Any electrical work must be completed by a qualified local electrician.'],
    [/No electrician, no building work\./gi, 'Any electrical work must be completed by a qualified local electrician.'],
    [/\bVolume da sauna\b/gi, 'Sauna volume'],
    [/\bTempo de aquecimento\b/gi, 'Heating time'],
    [/\bPreço\b/gi, 'Price'],
    [/\bAquecedor\b/gi, 'Heater'],
    [/\bInstalação\b/gi, 'Installation'],
    [/\bAcessórios\b/gi, 'Accessories'],
    [/a standard 230 V socket/gi, 'a suitable local power supply'],
    [/\bStandard 230 V socket\b/g, 'Local electrical connection']
  ];

  function normalizedPath(element) {
    try { return new URL(element.href, window.location.origin).pathname.toLowerCase(); }
    catch (error) { return ''; }
  }

  function hideRestrictedLinks(root) {
    var links = (root || document).querySelectorAll ? (root || document).querySelectorAll('a[href]') : [];
    Array.prototype.forEach.call(links, function (link) {
      var path = normalizedPath(link);
      var isHiddenPath = hiddenPaths.some(function (part) { return path.indexOf(part) !== -1; });
      var isForbiddenProduct = forbiddenOutdoorHandles.some(function (part) { return path.indexOf(part) !== -1; });
      if (!isHiddenPath && !isForbiddenProduct) return;

      var target = link;
      if (isForbiddenProduct) {
        target = link.closest('.product__card__phs, .product-card, .grid__item, li') || link;
      } else if (link.closest('header, nav, .drawer, .menu-drawer, [class*="mega"]')) {
        target = link.closest('li') || link;
      } else if (link.classList.contains('collection-list--card')) {
        target = link;
      }
      target.setAttribute('data-saunamo-us-hidden', 'true');
      target.style.setProperty('display', 'none', 'important');
    });
  }

  function hideRestrictedComparisonModels(root) {
    var restricted = { 'Cube 125': true, 'Cube 220': true, 'Cube 300': true, 'Hiki S': true, 'Hiki L': true };
    var cells = (root || document).querySelectorAll ? (root || document).querySelectorAll('.sm-compare-value-cell') : [];
    Array.prototype.forEach.call(cells, function (cell) {
      var label = cell.querySelector('.sm-compare-value__label');
      if (label && restricted[(label.textContent || '').trim()]) {
        cell.setAttribute('data-saunamo-us-hidden', 'true');
      }
    });
  }

  function hideNonSaunaHomepageSections(root) {
    if (!/^\/$/.test(window.location.pathname)) return;
    var headings = (root || document).querySelectorAll ? (root || document).querySelectorAll('.phs-heading, h2, h3') : [];
    Array.prototype.forEach.call(headings, function (heading) {
      var label = (heading.textContent || '').trim().toLowerCase();
      if (!/^(outdoor tubs|hot tubs|outlet)$/.test(label)) return;
      var section = heading.closest('.shopify-section, section, [id^="shopify-section-"]') || heading.parentElement;
      if (!section) return;
      section.setAttribute('data-saunamo-us-hidden', 'true');
      section.style.setProperty('display', 'none', 'important');
    });
  }

  function revealUsElement(element) {
    if (!element) return;
    element.removeAttribute('data-saunamo-us-hidden');
    element.style.removeProperty('display');
  }

  function setLinkLabel(link, label) {
    Array.prototype.forEach.call(link.childNodes || [], function (node) {
      if (node.nodeType === Node.TEXT_NODE && (node.nodeValue || '').trim()) node.nodeValue = label;
    });
    var title = link.querySelector('.collection-card--title');
    if (title) title.textContent = label;
  }

  function setLinkImage(link, imageUrl, alt) {
    var image = link.querySelector('img');
    if (!image) return;
    image.src = imageUrl;
    image.srcset = imageUrl;
    image.alt = alt;
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
  }

  function ensureUsCompleteCollectionCards() {
    var cards = [
      { path: '/collections/saunas-interior', aliases: ['/collections/saunas-interior', '/collections/indoor-saunas'], label: 'Indoor Saunas', image: INDOOR_COLLECTION_IMAGE, alt: 'Saunamo indoor saunas' },
      { path: '/collections/infrared-saunas', aliases: ['/collections/infrared-saunas'], label: 'Infrared Saunas', image: INFRARED_COLLECTION_IMAGE, alt: 'Aura infrared saunas' },
      { path: '/collections/saunas-exteriores', aliases: ['/collections/saunas-exteriores', '/collections/outdoor-saunas'], label: 'Outdoor Saunas', image: BARREL_COLLECTION_IMAGE, alt: 'Saunamo barrel outdoor saunas' },
      { path: '/collections/ice-baths', aliases: ['/collections/ice-baths', '/collections/banheiras-de-gelo'], label: 'Ice Baths', image: ICE_BATHS_COLLECTION_IMAGE, alt: 'Saunamo ice baths' },
      { path: '/collections/harvia-heaters', aliases: ['/collections/harvia-heaters'], label: 'Harvia Heaters', image: HARVIA_COLLECTION_IMAGE, alt: 'Harvia sauna heaters' },
      { path: '/collections/acessorios-para-saunas', aliases: ['/collections/acessorios-para-saunas', '/collections/sauna-accessories'], label: 'Accessories', image: ACCESSORIES_COLLECTION_IMAGE, alt: 'Sauna accessories' }
    ];

    Array.prototype.forEach.call(document.querySelectorAll('.collection-list--grid'), function (grid) {
      var section = grid.closest('.shopify-section, section, [id^="shopify-section-"]');
      var heading = section && section.querySelector('h2, h3, h4');
      var isExplore = heading && /^Explore our other collections$/i.test((heading.textContent || '').trim());
      var isHomepageCategories = window.location.pathname === '/' && grid.querySelector('a[href*="/collections/"]');
      if (!isExplore && !isHomepageCategories) return;

      var source = grid.querySelector('a.collection-list--card, a[href*="/collections/"]');
      if (!source) return;
      grid.setAttribute('data-saunamo-us-category-grid', 'true');
      if (section) section.style.setProperty('--collection-per-row', '6');

      cards.forEach(function (item) {
        var link = Array.prototype.find.call(grid.querySelectorAll('a[href*="/collections/"]'), function (candidate) {
          return item.aliases.indexOf(normalizedPath(candidate).replace(/\/$/, '')) !== -1;
        });
        if (!link) {
          link = source.cloneNode(true);
          grid.appendChild(link);
        }
        link.href = item.path;
        link.removeAttribute('data-saunamo-us-hidden');
        link.style.removeProperty('display');
        setLinkLabel(link, item.label);
        setLinkImage(link, item.image, item.alt);
        grid.appendChild(link);
      });

      var allowedPaths = cards.map(function (item) { return item.path; });
      Array.prototype.forEach.call(grid.querySelectorAll('a[href*="/collections/"]'), function (link) {
        if (allowedPaths.indexOf(normalizedPath(link).replace(/\/$/, '')) !== -1) return;
        link.setAttribute('data-saunamo-us-hidden', 'true');
        link.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function enforceUsIceBathCategoryCard() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-saunamo-us-category-grid] a[href="/collections/ice-baths"]'), function (link) {
      if (link.hasAttribute('data-saunamo-us-hidden')) link.removeAttribute('data-saunamo-us-hidden');
      if (link.style.getPropertyValue('display') === 'none') link.style.removeProperty('display');
    });
  }

  function installUsCategoryVisibilityGuard() {
    if (window.__saunamoUsCategoryVisibilityGuard) return;
    window.__saunamoUsCategoryVisibilityGuard = true;
    var observer = new MutationObserver(function (mutations) {
      var needsRepair = mutations.some(function (mutation) {
        var target = mutation.target;
        return target && target.matches && target.matches('[data-saunamo-us-category-grid] a[href="/collections/ice-baths"]');
      });
      if (needsRepair) window.requestAnimationFrame(enforceUsIceBathCategoryCard);
    });
    observer.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'data-saunamo-us-hidden']
    });
  }

  function isCollectionLandingLink(link, paths) {
    var path = normalizedPath(link).replace(/\/$/, '');
    return paths.indexOf(path) !== -1;
  }

  function restoreUsCatalogLinks(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll ? scope.querySelectorAll('a[href*="/collections/ice-baths"], a[href*="/collections/banheiras-de-gelo"]') : [], function (link) {
      if (!isCollectionLandingLink(link, ['/collections/ice-baths', '/collections/banheiras-de-gelo'])) return;
      link.href = '/collections/ice-baths';
      setLinkLabel(link, 'Ice Baths');
      revealUsElement(link);
      revealUsElement(link.closest('li, .collection-list--card'));
    });

    Array.prototype.forEach.call(scope.querySelectorAll ? scope.querySelectorAll('a[href*="/collections/sauna-heaters"], a[href*="/collections/aquecedores"]') : [], function (link) {
      if (!isCollectionLandingLink(link, ['/collections/sauna-heaters', '/collections/aquecedores', '/collections/aquecedores-de-sauna'])) return;
      link.href = '/collections/harvia-heaters';
      setLinkLabel(link, 'Harvia Heaters');
      setLinkImage(link, HARVIA_COLLECTION_IMAGE, 'Harvia sauna heaters');
      revealUsElement(link);
      revealUsElement(link.closest('li, .collection-list--card'));
    });

    if (/^\/$/.test(window.location.pathname)) {
      var grid = document.querySelector('.collection-list--grid');
      var sourceCard = grid && grid.querySelector('a[href="/collections/indoor-saunas"]');
      if (grid && sourceCard && !grid.querySelector('a[href="/collections/infrared-saunas"]')) {
        var infraredCard = sourceCard.cloneNode(true);
        infraredCard.href = '/collections/infrared-saunas';
        infraredCard.setAttribute('data-saunamo-us-infrared-card', 'true');
        setLinkLabel(infraredCard, 'Infrared Saunas');
        setLinkImage(infraredCard, INFRARED_COLLECTION_IMAGE, 'Aura infrared saunas');
        grid.insertBefore(infraredCard, sourceCard.nextSibling);
      }
    }

    Array.prototype.forEach.call(document.querySelectorAll('.megamenu-coll--listing'), function (list) {
      var source = list.querySelector('a[href="/collections/indoor-saunas"]');
      if (!source || list.querySelector('a[href="/collections/infrared-saunas"]')) return;
      var item = source.closest('li');
      if (!item) return;
      var clone = item.cloneNode(true);
      var link = clone.querySelector('a');
      link.href = '/collections/infrared-saunas';
      setLinkLabel(link, 'Infrared Saunas');
      setLinkImage(link, INFRARED_COLLECTION_IMAGE, 'Aura infrared saunas');
      item.parentNode.insertBefore(clone, item.nextSibling);
    });

    Array.prototype.forEach.call(document.querySelectorAll('h2, h3, h4'), function (heading) {
      if (!/^(ice baths|banheiras de gelo)$/i.test((heading.textContent || '').trim())) return;
      revealUsElement(heading.closest('.shopify-section, section, [id^="shopify-section-"]'));
    });
  }

  function ensureUsIceBathNavigation() {
    var links = document.querySelectorAll('header a[href="/collections/ice-baths"], header a[href="/collections/banheiras-de-gelo"], .shopify-section-group-header-group a[href="/collections/ice-baths"], .shopify-section-group-header-group a[href="/collections/banheiras-de-gelo"]');
    Array.prototype.forEach.call(links, function (link) {
      if (link.getAttribute('href') !== '/collections/ice-baths') link.setAttribute('href', '/collections/ice-baths');
      setLinkLabel(link, 'Ice Baths');
      if (link.getAttribute('title') !== 'Ice Baths') link.setAttribute('title', 'Ice Baths');
      revealUsElement(link);
      revealUsElement(link.closest('li'));
    });
  }

  function installUsIceBathNavigationGuard() {
    if (window.__saunamoUsIceBathNavigationGuard) return;
    var header = document.querySelector('.shopify-section-group-header-group, header');
    if (!header) return;
    window.__saunamoUsIceBathNavigationGuard = true;
    var observer = new MutationObserver(function () {
      ensureUsIceBathNavigation();
    });
    observer.observe(header, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'data-saunamo-us-hidden', 'href']
    });
  }

  function hideUsCollectionEditorialSections() {
    var path = (window.location.pathname || '').toLowerCase().replace(/\/$/, '');
    if (['/collections/infrared-saunas', '/collections/ice-baths', '/collections/harvia-heaters'].indexOf(path) === -1) return;
    if (path === '/collections/harvia-heaters' || path === '/collections/infrared-saunas' || path === '/collections/ice-baths') {
      Array.prototype.forEach.call(document.querySelectorAll('.shopify-section'), revealUsElement);
      return;
    }
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section'), function (section) {
      if (section.matches('.shopify-section-group-header-group, .shopify-section-group-footer-group, .shopify-section-group-overlay-group, .collection-banner-section, .collection-section, .section-collection-list')) return;
      if (path === '/collections/ice-baths' && /__custom_featured_collection_/i.test(section.id || '')) return;
      section.setAttribute('data-saunamo-us-hidden', 'true');
      section.style.setProperty('display', 'none', 'important');
    });
  }

  function repairUsCollectionProductCards() {
    var path = (window.location.pathname || '').toLowerCase().replace(/\/$/, '');
    if (['/collections/infrared-saunas', '/collections/ice-baths', '/collections/harvia-heaters'].indexOf(path) === -1) return;
    Array.prototype.forEach.call(document.querySelectorAll('product-card'), function (card) {
      var quickView = card.querySelector('quick-view[data-product-url]');
      var productUrl = quickView && quickView.getAttribute('data-product-url');
      Array.prototype.forEach.call(card.querySelectorAll('.main-card-image, .product-card-title a'), function (link) {
        if (productUrl) link.href = productUrl;
        revealUsElement(link);
      });
    });
  }

  function centerUsInfraredProductGrid() {
    var path = (window.location.pathname || '').toLowerCase().replace(/\/$/, '');
    if (path !== '/collections/infrared-saunas') return;
    var grid = document.querySelector('.collection-product--results .product-card-list');
    if (grid) grid.setAttribute('data-saunamo-us-infrared-products', 'true');
  }

  function polishUsHeaterLayouts() {
    var path = (window.location.pathname || '').toLowerCase().replace(/\/$/, '');
    if (path === '/collections/harvia-heaters') {
      var heaterGrid = document.querySelector('.phs-wrapper');
      if (heaterGrid) heaterGrid.setAttribute('data-saunamo-us-heater-grid', 'true');
    }
    if (path === '/products/harvia-m3-wood-burning-sauna-heater') {
      var gallery = document.querySelector('product-gallery-media.main-product-media-wrapper');
      if (gallery) gallery.setAttribute('data-saunamo-us-m3-gallery', 'true');
    }
    if (/^\/products\/(?:aura-(?:110|150|220)-infrared-sauna|sauna-infravermelho-aura-220)$/.test(path)) {
      var auraGallery = document.querySelector('product-gallery-media.main-product-media-wrapper');
      if (auraGallery) auraGallery.setAttribute('data-saunamo-us-aura-gallery', 'true');
    }
  }

  function hideUsShowroom(root) {
    if (!/^\/pages\/(?:contato|contact)\/?$/.test((window.location.pathname || '').toLowerCase())) return;
    var headings = (root || document).querySelectorAll ? (root || document).querySelectorAll('h1, h2, h3, h4, h5') : [];
    Array.prototype.forEach.call(headings, function (heading) {
      if (!/^Visit us at our showroom$/i.test((heading.textContent || '').trim())) return;
      var block = heading.closest('.multi-image-with--text-wrapper') || heading.parentElement;
      if (!block) return;
      block.setAttribute('data-saunamo-us-hidden', 'true');
      block.style.setProperty('display', 'none', 'important');
    });
  }

  function installUsConfiguratorDepositGuard() {
    if (window.__saunamoUsDepositFetchGuard) return;
    window.__saunamoUsDepositFetchGuard = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var nextInit = init;
      var usRequest = false;
      if (url.indexOf('/api/quotes/generateFromEmbed') !== -1 && init && typeof init.body === 'string') {
        try {
          var requestBody = JSON.parse(init.body);
          if (requestBody.store === 'us') {
            usRequest = true;
            requestBody.depositLinkRequested = true;
            nextInit = Object.assign({}, init, { body: JSON.stringify(requestBody) });
          }
        } catch (error) {}
      }
      return originalFetch.call(this, input, nextInit).then(function (response) {
        if (usRequest) {
          response.clone().json().then(function (data) {
            var paymentUrl = data && (
              data.depositPaymentUrl ||
              data.depositCheckoutUrl ||
              data.paymentLink ||
              data.invoiceUrl
            );
            if (!data || !data.success || !paymentUrl) return;
            window.__saunamoUsDepositCheckout = {
              url: paymentUrl,
              amount: data.depositAmount
            };
            window.requestAnimationFrame(function () { installUsDepositCta(document); });
          }).catch(function () {});
        }
        return response;
      });
    };
  }

  function installUsDepositCta(root) {
    var payment = window.__saunamoUsDepositCheckout;
    if (!payment || !payment.url) return;
    var wraps = (root || document).querySelectorAll ? (root || document).querySelectorAll('#dyn-configurador .wz-reveal-wrap') : [];
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.querySelector('.saunamo-us-deposit-cta')) return;
      var button = document.createElement('a');
      button.className = 'saunamo-us-deposit-cta';
      button.href = payment.url;
      button.textContent = payment.amount
        ? 'Reserve now with 50% deposit ($' + Number(payment.amount).toLocaleString('en-US') + ')'
        : 'Reserve now with 50% deposit';
      var secondary = wrap.querySelector('.wz-reveal-cta-secondary');
      if (secondary) wrap.insertBefore(button, secondary);
      else wrap.appendChild(button);
    });
  }

  function presentAuraAsReadyPackage(root) {
    var configurator = document.querySelector('#dyn-configurador[data-slug^="aura-"]');
    if (!configurator) return;
    var slug = (configurator.getAttribute('data-slug') || '').toLowerCase();
    var packages = {
      'aura-110': {
        title: 'Aura 110 Infrared Sauna',
        total: 6200,
        capacity: 'Compact one-person infrared sauna',
        image: 'https://cdn.shopify.com/s/files/1/0714/8562/0513/files/sauna-infravermelho-aura-110-1477056.png?v=1785310214'
      },
      'aura-150': {
        title: 'Aura 150 Infrared Sauna',
        total: 7700,
        capacity: 'Comfortable two-person infrared sauna',
        image: 'https://cdn.shopify.com/s/files/1/0714/8562/0513/files/sauna-infravermelho-aura-150-5858649.png?v=1785310215'
      },
      'aura-220': {
        title: 'Aura 220 Infrared Sauna',
        total: 9449,
        capacity: 'Spacious three-person infrared sauna',
        image: 'https://cdn.shopify.com/s/files/1/0714/8562/0513/files/sauna-infravermelho-aura-220-3977730.png?v=1785807374'
      }
    };
    var packageData = packages[slug];
    if (!packageData) return;
    function formatUsd(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: value % 1 ? 2 : 0,
        maximumFractionDigits: value % 1 ? 2 : 0
      }).format(value);
    }
    configurator.setAttribute('data-saunamo-us-aura-ready', 'true');
    if (!configurator.hasAttribute('data-saunamo-us-aura-view')) {
      configurator.setAttribute('data-saunamo-us-aura-view', 'card');
    }
    var title = configurator.querySelector('#wzDynTitle');
    var intro = configurator.querySelector('#wzDynIntro');
    if (title) title.textContent = 'Choose your Aura ready-to-use set';
    if (intro) intro.textContent = 'Review what is included, select your delivery destination and reserve your sauna with a 50% deposit.';
    var phase = configurator.querySelector('.wz-phases');
    if (phase) phase.setAttribute('data-saunamo-us-hidden', 'true');
    var activeTitle = configurator.querySelector('.wz-step.is-active .wz-step-title');
    var activeIntro = configurator.querySelector('.wz-step.is-active .wz-step-intro');
    if (activeTitle && /^Confirm delivery$/i.test((activeTitle.textContent || '').trim())) activeTitle.textContent = 'Complete Aura package with US delivery';
    if (activeIntro && /standard delivery price/i.test(activeIntro.textContent || '')) activeIntro.textContent = 'Your Aura sauna is supplied as a complete ready-to-go package. Delivery from Portugal to the United States is $950; final site access details are confirmed before production.';
    var next = configurator.querySelector('#wzDynNext');
    if (next && /View summary/i.test(next.textContent || '')) next.innerHTML = 'Review package & reserve <span class="wz-arrow">&rarr;</span>';

    document.querySelectorAll('.sm-cube220-topfold__price-note').forEach(function (element) {
      element.textContent = 'Complete ready-to-use package shown below · standard US delivery included in the package total';
    });
    document.querySelectorAll('.sm-cube220-topfold__btn-label').forEach(function (element) {
      if (/Aura/i.test(element.textContent || '')) element.textContent = 'Choose Aura ready-to-use set';
    });

    var inner = configurator.querySelector('.wzc-inner');
    var body = configurator.querySelector('#wzDynBody');
    if (!inner || !body) return;
    var card = configurator.querySelector('[data-saunamo-us-aura-card]');
    if (!card) {
      card = document.createElement('article');
      card.className = 'saunamo-us-aura-ready-card';
      card.setAttribute('data-saunamo-us-aura-card', 'true');
      card.innerHTML = '' +
        '<div class="saunamo-us-aura-ready-card__media">' +
          '<img alt="" loading="eager">' +
          '<span class="saunamo-us-aura-ready-card__tag">&#10003; SAUNAMO RECOMMENDS</span>' +
          '<div class="saunamo-us-aura-ready-card__price"><span>ready-to-use package</span><strong></strong><small>USD pricing · standard US delivery included</small></div>' +
        '</div>' +
        '<div class="saunamo-us-aura-ready-card__content">' +
          '<h3>Ready-to-use set</h3>' +
          '<p class="saunamo-us-aura-ready-card__intro"></p>' +
          '<ul>' +
            '<li>Integrated full-spectrum infrared panels</li>' +
            '<li>Digital controls, Bluetooth and ambient LED lighting</li>' +
            '<li>Complete cabin and bench set</li>' +
            '<li>DIY-friendly assembly with supplied instructions</li>' +
            '<li>Standard delivery to the United States</li>' +
          '</ul>' +
          '<button type="button" data-saunamo-us-aura-card-button>Choose ready-to-use set <span>&rarr;</span></button>' +
          '<p class="saunamo-us-aura-ready-card__deposit"></p>' +
        '</div>';
      inner.insertBefore(card, body);
    }
    var detail = configurator.querySelector('[data-saunamo-us-aura-detail]');
    if (!detail) {
      detail = document.createElement('article');
      detail.className = 'wz-rec-bundle saunamo-us-aura-ready-detail';
      detail.setAttribute('data-saunamo-us-aura-detail', 'true');
      detail.innerHTML = '' +
        '<div class="wz-rec-bundle__corner-seal">&#10003;</div>' +
        '<div class="wz-rec-bundle__banner"><span class="wz-rec-bundle__banner-seal">&#10003;</span> SAUNAMO RECOMMENDS &middot; MOST POPULAR CHOICE</div>' +
        '<div class="wz-rec-bundle__body">' +
          '<div class="wz-rec-bundle__head">' +
            '<div><h4 class="wz-rec-bundle__title">Ready-to-use set</h4>' +
            '<p class="wz-rec-bundle__desc">Everything has been selected for you. The complete infrared sauna, controls and delivery are included from start to finish.</p></div>' +
            '<div class="wz-rec-bundle__price"><span class="wz-rec-bundle__price-amt"></span><span class="wz-rec-bundle__price-lbl">USD pricing &middot; delivery selected below &middot; on-site assembly not included</span></div>' +
          '</div>' +
          '<div class="wz-rec-bundle__kit kit-many" data-saunamo-us-aura-kit></div>' +
          '<div class="wz-rec-bundle__region"><label id="saunamoUsAuraRegionLabel">Deliver to</label>' +
            '<div class="wz-rec-region" data-saunamo-us-aura-region>' +
              '<button type="button" class="wz-rec-region__trigger" aria-haspopup="listbox" aria-expanded="false" aria-labelledby="saunamoUsAuraRegionLabel saunamoUsAuraRegionValue">' +
                '<span class="wz-rec-region__value" id="saunamoUsAuraRegionValue">United States</span>' +
                '<span class="wz-rec-region__price" data-saunamo-us-aura-region-price>$950</span>' +
                '<svg class="wz-rec-region__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>' +
              '</button>' +
              '<ul class="wz-rec-region__menu" role="listbox" tabindex="-1">' +
                '<li class="wz-rec-region__opt is-selected" role="option" data-region="usa" aria-selected="true"><span class="wz-rec-region__opt-name">United States</span><span class="wz-rec-region__opt-price">$950</span></li>' +
                '<li class="wz-rec-region__opt" role="option" data-region="other" aria-selected="false"><span class="wz-rec-region__opt-name">Other destination</span><span class="wz-rec-region__opt-price">To be confirmed</span></li>' +
              '</ul>' +
            '</div>' +
          '</div>' +
          '<div class="wz-rec-bundle__region" data-saunamo-us-aura-other-wrap hidden><label for="saunamoUsAuraOtherInput">Where to?</label><input type="text" id="saunamoUsAuraOtherInput" class="wz-rec-other__input" placeholder="Country or region" maxlength="80"></div>' +
          '<button type="button" class="wz-rec-bundle__btn" data-saunamo-us-aura-detail-button>Choose recommended set <span>&rarr;</span></button>' +
          '<p class="wz-rec-bundle__deposit" data-saunamo-us-aura-detail-deposit></p>' +
          '<div class="wz-rec-inline" data-saunamo-us-aura-inline hidden></div>' +
        '</div>' +
        '<button type="button" class="saunamo-us-aura-ready-detail__back" data-saunamo-us-aura-overview>&larr; Back to overview</button>';
      inner.insertBefore(detail, body);
    }
    var image = card.querySelector('img');
    if (image) {
      image.src = packageData.image;
      image.alt = packageData.title;
    }
    var price = card.querySelector('.saunamo-us-aura-ready-card__price strong');
    if (price) price.textContent = 'from ' + formatUsd(packageData.total);
    var cardIntro = card.querySelector('.saunamo-us-aura-ready-card__intro');
    if (cardIntro) cardIntro.textContent = packageData.capacity + '. Everything required for the infrared sauna is supplied as one straightforward package.';
    var deposit = card.querySelector('.saunamo-us-aura-ready-card__deposit');
    if (deposit) deposit.textContent = 'To proceed, reserve with 50% of the total. The balance is due before delivery. (' + formatUsd(packageData.total / 2) + ')';
    var detailPrice = detail.querySelector('.wz-rec-bundle__price-amt');
    if (detailPrice) detailPrice.textContent = formatUsd(packageData.total);
    var detailDeposit = detail.querySelector('[data-saunamo-us-aura-detail-deposit]');
    if (detailDeposit) detailDeposit.textContent = 'To proceed, reserve with 50% of the total. The balance is due before delivery. (' + formatUsd(packageData.total / 2) + ')';
    var galleryImages = Array.prototype.map.call(document.querySelectorAll('product-gallery-media img'), function (galleryImage) {
      return galleryImage.currentSrc || galleryImage.src || '';
    }).filter(function (src, index, list) {
      return src && list.indexOf(src) === index;
    });
    var sharedControlImage = 'https://cdn.shopify.com/s/files/1/0714/8562/0513/files/sauna-infravermelho-aura-110-5996606.png?v=1784895921';
    var sharedAmbientImage = "https://cdn.shopify.com/s/files/1/0714/8562/0513/t/113/assets/saunamo-us-aura-red-light-panel-20260828.png?v=1787898592";
    var kitPlans = {
      'aura-110': [
        { label: packageData.title, image: galleryImages[0] },
        { label: 'Integrated full-spectrum infrared panels', image: galleryImages[5] },
        { label: 'Digital controls', image: galleryImages[2] },
        { label: 'Ambient LED lighting', image: sharedAmbientImage }
      ],
      'aura-150': [
        { label: packageData.title, image: galleryImages[0] },
        { label: 'Integrated full-spectrum infrared panels', image: galleryImages[3] },
        { label: 'Digital controls', image: sharedControlImage },
        { label: 'Ambient LED lighting', image: sharedAmbientImage }
      ],
      'aura-220': [
        { label: packageData.title, image: galleryImages[0] },
        { label: 'Integrated full-spectrum infrared panels', image: galleryImages[2] },
        { label: 'Digital controls', image: galleryImages[3] || sharedControlImage },
        { label: 'Ambient LED lighting', image: sharedAmbientImage }
      ]
    };
    var kitItems = kitPlans[slug] || kitPlans['aura-110'];
    var kit = detail.querySelector('[data-saunamo-us-aura-kit]');
    if (kit && !kit.hasAttribute('data-saunamo-us-aura-kit-corrected')) {
      kit.innerHTML = kitItems.map(function (item) {
        var kitImage = item.image || packageData.image;
        return '<div class="wz-rec-bundle__kit-item"><div class="wz-rec-bundle__kit-thumb"><img src="' + kitImage + '" alt="' + item.label + '" loading="lazy"></div><div class="wz-rec-bundle__kit-label"><span class="saunamo-us-aura-kit-check">&#10003;</span><span>' + item.label + '</span></div></div>';
      }).join('');
      kit.setAttribute('data-saunamo-us-aura-kit-ready', 'true');
      kit.setAttribute('data-saunamo-us-aura-kit-corrected', 'true');
    }
    var inclusions = detail.querySelector('[data-saunamo-us-aura-inclusions]');
    if (!inclusions && kit) {
      inclusions = document.createElement('ul');
      inclusions.className = 'saunamo-us-aura-inclusions';
      inclusions.setAttribute('data-saunamo-us-aura-inclusions', 'true');
      inclusions.innerHTML = '<li>Bluetooth audio</li><li>Complete cabin and bench set</li><li>DIY-friendly assembly with supplied instructions</li><li>Standard delivery to the United States</li>';
      kit.insertAdjacentElement('afterend', inclusions);
    }
    card.hidden = configurator.getAttribute('data-saunamo-us-aura-view') !== 'card';
    detail.hidden = configurator.getAttribute('data-saunamo-us-aura-view') !== 'detail';

    var backButton = detail.querySelector('[data-saunamo-us-aura-overview]');
    if (backButton && backButton.nextElementSibling !== detail) inner.insertBefore(backButton, detail);
    var region = detail.querySelector('[data-saunamo-us-aura-region]');
    if (region && !region.hasAttribute('data-saunamo-us-aura-region-ready')) {
      region.setAttribute('data-saunamo-us-aura-region-ready', 'true');
      var trigger = region.querySelector('.wz-rec-region__trigger');
      var menu = region.querySelector('.wz-rec-region__menu');
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        region.classList.toggle('is-open', !open);
      });
      menu.addEventListener('click', function (event) {
        var option = event.target.closest('.wz-rec-region__opt');
        if (!option) return;
        var isOther = option.getAttribute('data-region') === 'other';
        menu.querySelectorAll('.wz-rec-region__opt').forEach(function (item) {
          var selected = item === option;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
        detail.querySelector('.wz-rec-region__value').textContent = isOther ? 'Other destination' : 'United States';
        detail.querySelector('[data-saunamo-us-aura-region-price]').textContent = isOther ? 'To be confirmed' : '$950';
        var otherWrap = detail.querySelector('[data-saunamo-us-aura-other-wrap]');
        if (otherWrap) otherWrap.hidden = !isOther;
        var action = detail.querySelector('[data-saunamo-us-aura-detail-button]');
        if (action) {
          action.disabled = false;
          action.innerHTML = isOther ? 'Request delivery quote <span>&rarr;</span>' : 'Choose recommended set <span>&rarr;</span>';
        }
        detail.setAttribute('data-saunamo-us-aura-destination', isOther ? 'other' : 'usa');
        var deliveryCard = configurator.querySelector('[data-opt-id="delivery-standard"][data-step-id="delivery"]');
        if (deliveryCard && isOther === deliveryCard.classList.contains('is-selected')) deliveryCard.click();
        trigger.setAttribute('aria-expanded', 'false');
        region.classList.remove('is-open');
      });
      var otherInput = detail.querySelector('#saunamoUsAuraOtherInput');
      if (otherInput) otherInput.addEventListener('input', function () {
        detail.setAttribute('data-saunamo-us-aura-other-destination', otherInput.value.trim());
      });
    }

    if (!configurator.hasAttribute('data-saunamo-us-aura-card-events')) {
      configurator.setAttribute('data-saunamo-us-aura-card-events', 'true');
      configurator.addEventListener('click', function (event) {
        var choose = event.target.closest('[data-saunamo-us-aura-card-button]');
        if (choose) {
          configurator.setAttribute('data-saunamo-us-aura-view', 'detail');
          card.hidden = true;
          detail.hidden = false;
          if (detail.scrollIntoView) detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (event.target.closest('[data-saunamo-us-aura-detail-button]')) {
          var inline = detail.querySelector('[data-saunamo-us-aura-inline]');
          var existingForm = inline && inline.querySelector('.wz-summary-lead-form');
          if (existingForm) {
            inline.hidden = false;
            event.target.closest('[data-saunamo-us-aura-detail-button]').hidden = true;
            return;
          }
          var nextButton = configurator.querySelector('#wzDynNext');
          if (nextButton) nextButton.click();
          window.setTimeout(function () {
            updateUsQuoteForm(document);
            var form = configurator.querySelector('.wz-summary-lead-form');
            if (!inline || !form) return;
            var totalLine = form.querySelector('[data-saunamo-us-aura-inline-total]');
            if (!totalLine) {
              totalLine = document.createElement('p');
              totalLine.className = 'wz-rec-buy-full';
              totalLine.setAttribute('data-saunamo-us-aura-inline-total', 'true');
              totalLine.textContent = 'Total price ' + formatUsd(packageData.total);
              var submit = form.querySelector('#wzDynLeadSubmit');
              form.insertBefore(totalLine, submit || null);
            }
            var isOtherDestination = detail.getAttribute('data-saunamo-us-aura-destination') === 'other';
            if (isOtherDestination) {
              var destination = detail.getAttribute('data-saunamo-us-aura-other-destination') || 'Other destination';
              var note = form.querySelector('#wzDynLeadNote');
              if (note) note.value = 'Delivery destination: ' + destination + '. Delivery availability and price to be confirmed.';
              totalLine.textContent = 'Delivery to ' + destination + ' · price to be confirmed';
              var steps = form.querySelector('[data-saunamo-us-aura-payment-steps]');
              if (steps) steps.innerHTML = '<li><strong>1</strong><span>Leave your details</span></li><li><strong>2</strong><span>We confirm delivery availability and price</span></li><li><strong>3</strong><span>Our specialist contacts you within 24 hours</span></li>';
              var submit = form.querySelector('#wzDynLeadSubmit');
              if (submit) submit.innerHTML = 'Request delivery quote <span class="wz-arrow">&rarr;</span>';
            }
            inline.appendChild(form);
            inline.hidden = false;
            detail.hidden = false;
            configurator.setAttribute('data-saunamo-us-aura-view', 'detail');
            var cta = detail.querySelector('[data-saunamo-us-aura-detail-button]');
            if (cta) cta.hidden = true;
            if (inline.scrollIntoView) inline.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 80);
          return;
        }
        if (event.target.closest('[data-saunamo-us-aura-overview]')) {
          configurator.setAttribute('data-saunamo-us-aura-view', 'card');
          detail.hidden = true;
          card.hidden = false;
          if (card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (event.target.closest('#wzDynBack')) {
          window.setTimeout(function () {
            configurator.setAttribute('data-saunamo-us-aura-view', 'detail');
            card.hidden = true;
            detail.hidden = false;
            if (detail.scrollIntoView) detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 0);
        }
      });
    }
  }

  function updateUsQuoteForm(root) {
    var title = document.querySelector('#dyn-configurador .wz-summary-lead-intro h4');
    var intro = document.querySelector('#dyn-configurador .wz-summary-lead-intro p');
    var submit = document.querySelector('#dyn-configurador #wzDynLeadSubmit');
    var configurator = document.querySelector('#dyn-configurador');
    var auraSlug = configurator && (configurator.getAttribute('data-slug') || '').toLowerCase();
    var auraTotals = { 'aura-110': 6200, 'aura-150': 7700, 'aura-220': 9449 };
    var auraTotal = auraTotals[auraSlug];
    if (auraTotal) {
      if (title) title.textContent = 'Reserve your Aura ready-to-go set';
      if (intro) intro.textContent = 'Leave your details, reserve with 50% through the secure payment link, and our specialist will confirm delivery with you.';
      if (submit) submit.innerHTML = 'Reserve now with 50% deposit — $' + Number(auraTotal / 2).toLocaleString('en-US') + ' <span class="wz-arrow">&rarr;</span>';
      var leadForm = document.querySelector('#dyn-configurador .wz-summary-lead-form');
      if (leadForm && !leadForm.querySelector('[data-saunamo-us-aura-payment-steps]')) {
        var steps = document.createElement('ol');
        steps.className = 'saunamo-us-aura-payment-steps';
        steps.setAttribute('data-saunamo-us-aura-payment-steps', 'true');
        steps.innerHTML = '<li><strong>1</strong><span>Leave your details</span></li><li><strong>2</strong><span>Reserve with 50% — we provide the secure payment link</span></li><li><strong>3</strong><span>Our specialist confirms delivery with you</span></li>';
        leadForm.insertBefore(steps, leadForm.firstChild);
      }
      return;
    }
    if (title) title.textContent = 'Where should we send your quote?';
    if (intro) intro.textContent = 'Enter your details to receive the quote by email. We will also prepare a secure link if you would like to reserve the order with a 50% deposit.';
    if (submit && !submit.disabled) submit.innerHTML = 'Create quote & reservation link <span class="wz-arrow">&rarr;</span>';
  }

  function replaceCollectionImage(root) {
    var links = (root || document).querySelectorAll ? (root || document).querySelectorAll('a[href*="/collections/outdoor-saunas"]') : [];
    Array.prototype.forEach.call(links, function (link) {
      var image = link.querySelector('img');
      if (!image) return;
      image.src = BARREL_COLLECTION_IMAGE;
      image.srcset = BARREL_COLLECTION_IMAGE;
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
    });
  }

  function setEnglishLanguageUi(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll ? scope.querySelectorAll('.saunamo-native-language') : [], function (control) {
      var flag = control.querySelector('.saunamo-native-language__button .saunamo-native-language__flag');
      var code = control.querySelector('.saunamo-native-language__button .saunamo-native-language__code');
      var list = control.querySelector('.saunamo-native-language__list');
      if (flag) flag.textContent = '🇺🇸';
      if (code) code.textContent = 'EN';
      if (list) list.style.setProperty('display', 'none', 'important');
      control.removeAttribute('open');
    });
  }

  function forceUsConfigurator(root) {
    var frames = (root || document).querySelectorAll ? (root || document).querySelectorAll('iframe[src*="config.saunamo"]') : [];
    Array.prototype.forEach.call(frames, function (frame) {
      try {
        var url = new URL(frame.src, window.location.origin);
        if (url.hostname !== 'config.saunamo.pt') url.hostname = 'config.saunamo.pt';
        url.searchParams.set('store', 'us');
        url.searchParams.set('lang', 'en');
        if (frame.src !== url.toString()) frame.src = url.toString();
      } catch (error) {}
    });

    var links = (root || document).querySelectorAll ? (root || document).querySelectorAll('a[href*="config.saunamo"]') : [];
    Array.prototype.forEach.call(links, function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        url.hostname = 'config.saunamo.pt';
        url.searchParams.set('store', 'us');
        url.searchParams.set('lang', 'en');
        link.href = url.toString();
      } catch (error) {}
    });
  }

  function installUsConfiguratorClickGuard() {
    if (window.__saunamoUsConfiguratorClickGuard) return;
    window.__saunamoUsConfiguratorClickGuard = true;
    window.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href*="config.saunamo"]') : null;
      if (!link) return;
      try {
        var url = new URL(link.href, window.location.origin);
        url.hostname = 'config.saunamo.pt';
        url.searchParams.set('store', 'us');
        url.searchParams.set('lang', 'en');
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = url.toString();
      } catch (error) {}
    }, true);
  }

  function installUsCustomConfiguratorViewGuard() {
    if (window.__saunamoUsCustomViewGuard) return;
    window.__saunamoUsCustomViewGuard = true;
    window.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('#smPcCustomBtn') : null;
      if (!button) return;
      window.setTimeout(function () {
        var configurator = button.closest('#dyn-configurador');
        if (!configurator) return;
        configurator.classList.remove('sm-pc-pending');
      }, 0);
    }, true);
  }

  function translateTextNode(node) {
    if (!node || !node.nodeValue) return;
    var parent = node.parentElement;
    if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.tagName)) return;
    var original = node.nodeValue;
    var trimmed = original.trim();
    var translated = exactCopy[trimmed] || trimmed;
    phraseCopy.forEach(function (rule) { translated = translated.replace(rule[0], rule[1]); });
    if (translated !== trimmed) node.nodeValue = original.replace(trimmed, translated);
  }

  function translateTree(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(translateTextNode);
  }

  function translateB2bPage(root) {
    if (!/^\/pages\/sauna-manufacturer-b2b\/?$/.test((window.location.pathname || '').toLowerCase())) return;
    var exact = {
      'Torne-se Revendedor': 'Become a Reseller',
      'A Saunamo trabalha com uma rede focada de parceiros profissionais que partilham os nossos padrões e a nossa forma de trabalhar. Se atua no retalho de bem-estar, hotelaria, construção ou design, poderá haver uma parceria que vale a pena explorar.': 'Saunamo works with a focused network of professional partners who share our standards and way of working. If you work in wellness retail, hospitality, construction or design, there may be a partnership worth exploring.',
      'Desenhamos e fabricamos soluções de sauna, terapia de contraste e hidroterapia enraizadas na tradição finlandesa e no artesanato europeu. Os nossos revendedores beneficiam de produtos de alta qualidade, suporte técnico dedicado e uma marca com credibilidade crescente em toda a Europa.': 'We design and manufacture sauna, contrast therapy and hydrotherapy solutions rooted in Finnish tradition and European craftsmanship. Our resellers benefit from high-quality products, dedicated technical support and a brand with growing credibility across Europe.',
      'O Que Oferecemos aos Nossos Revendedores': 'What We Offer Our Resellers',
      'O Que Oferecemos aos Nossos Dealers': 'What We Offer Our Resellers',
      'Equipamos os nossos parceiros com as ferramentas necessárias para vender, instalar e apoiar os produtos Saunamo com confiança. Isto inclui materiais de marketing, suporte técnico, formação de produto e acesso a toda a nossa gama.': 'We equip our partners with the tools needed to sell, install and support Saunamo products with confidence. This includes marketing materials, technical support, product training and access to our full range.',
      'Quem pode tornar-se revendedor?': 'Who can become a reseller?',
      'Estúdios e centros de bem-estar que utilizam sauna e terapia de frio para recuperação e longevidade.': 'Studios and wellbeing centres that use sauna and cold therapy for recovery and longevity.',
      'Preferimos uma rede focada de parceiros fortes a uma expansão rápida. O nosso papel é fornecer produtos de qualidade, suporte técnico fiável e uma parceria de longo prazo baseada na confiança mútua.': 'We prefer a focused network of strong partners over rapid expansion. Our role is to provide quality products, reliable technical support and a long-term partnership based on mutual trust.',
      'Torne-se Parceiro Saunamo': 'Become a Saunamo Partner',
      'Se atua no retalho de bem-estar, hotelaria ou construção e tem interesse em representar a Saunamo na sua região, gostaríamos de saber mais sobre si. Envie-nos uma mensagem e conte-nos sobre o seu projeto.': 'If you work in wellness retail, hospitality or construction and are interested in representing Saunamo in your region, we would like to hear more about you. Send us a message and tell us about your project.'
    };
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!node || !node.nodeValue) return;
      var parent = node.parentElement;
      if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.tagName)) return;
      var original = node.nodeValue;
      var trimmed = original.trim();
      if (exact[trimmed]) node.nodeValue = original.replace(trimmed, exact[trimmed]);
    });
  }

  function translateUsAttributes(root) {
    var elements = (root || document).querySelectorAll ? (root || document).querySelectorAll('[alt], [title], [aria-label]') : [];
    Array.prototype.forEach.call(elements, function (element) {
      ['alt', 'title', 'aria-label'].forEach(function (attribute) {
        if (!element.hasAttribute(attribute)) return;
        var value = element.getAttribute(attribute) || '';
        var translated = value
          .replace(/Sauna Infravermelho/gi, 'Infrared Sauna')
          .replace(/Sauna Interior/gi, 'Indoor Sauna')
          .replace(/Sauna Exterior/gi, 'Outdoor Sauna')
          .replace(/Banheira de Gelo/gi, 'Ice Bath')
          .replace(/\bDuche\b/gi, 'Shower');
        if (translated !== value) element.setAttribute(attribute, translated);
      });
    });
  }

  function removeUnsupportedUsContent(root) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-saunamo-us-delivery-note]'), function (note) {
      note.remove();
    });
    Array.prototype.forEach.call(document.querySelectorAll('.snm-chip[data-val="sauna-med"]'), function (chip) {
      chip.remove();
    });
    var unsupportedSaunaCopy = [
      [/\bfully custom(?:ized|ised) sauna solutions\b/gi, 'standard sauna models'],
      [/\bcustom saunas\b/gi, 'sauna models'],
      [/\bcustom sauna\b/gi, 'sauna model'],
      [/\bbespoke saunas\b/gi, 'sauna models'],
      [/\bbespoke sauna\b/gi, 'sauna model']
    ];
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (node) {
      if (!node.parentElement || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(node.parentElement.tagName)) return;
      var next = node.nodeValue || '';
      unsupportedSaunaCopy.forEach(function (pair) { next = next.replace(pair[0], pair[1]); });
      if (next !== node.nodeValue) node.nodeValue = next;
    });
    var headings = (root || document).querySelectorAll ? (root || document).querySelectorAll('h2, h3, h4') : [];
    Array.prototype.forEach.call(headings, function (heading) {
      if (!/custom sauna/i.test((heading.textContent || '').trim())) return;
      var section = heading.closest('.shopify-section, section, [id^="shopify-section-"]') || heading.parentElement;
      if (!section) return;
      section.setAttribute('data-saunamo-us-hidden', 'true');
      section.style.setProperty('display', 'none', 'important');
    });
    if (!/\/products\//.test(window.location.pathname)) return;
    var elements = (root || document).querySelectorAll ? (root || document).querySelectorAll('li, [role="listitem"]') : [];
    Array.prototype.forEach.call(elements, function (element) {
      if ((element.textContent || '').trim() === 'Interior wood treatment') {
        element.setAttribute('data-saunamo-us-hidden', 'true');
      }
    });
  }

  function removeUsAssemblyGuidance() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-saunamo-us-assembly-guidance]'), function (note) {
      note.remove();
    });
  }

  function rewriteUsReceiveOrAssemble(root) {
    if (!/\/products\//.test(window.location.pathname || '')) return;
    var lumia = /lumia/i.test(window.location.pathname || '');
    var source = 'You can receive the sauna ready to use or assemble it yourself.';
    var next = lumia
      ? 'Your sauna arrives factory-complete. Saunamo does not provide on-site assembly or installation in the United States. The customer arranges unloading, placement and any final electrical or plumbing connections with suitable local professionals.'
      : 'You can assemble it yourself with the supplied instructions, or ask a local handyman or contractor to help. On-site assembly is not included in the United States.';
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!node || !node.nodeValue) return;
      var original = node.nodeValue;
      var trimmed = original.trim();
      if (trimmed === source) node.nodeValue = original.replace(trimmed, next);
    });
  }

  // saunamo-us-unavailable-configurators-20260825
  function replaceUnavailableUsConfigurator() {
    var path = (window.location.pathname || '').toLowerCase();
    var unavailable = /^\/products\/(?:outdoor-sauna-(?:hiki-[sl]|cube-(?:125|220|300)))\/?$/.test(path);
    if (!unavailable) return;

    var meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    meta.content = 'noindex, nofollow';

    var configurator = document.querySelector('#dyn-configurador');
    if (!configurator || configurator.getAttribute('data-saunamo-us-unavailable') === 'true') return;
    configurator.setAttribute('data-saunamo-us-unavailable', 'true');
    configurator.innerHTML = '<section class="saunamo-us-unavailable-config">' +
      '<p class="saunamo-us-unavailable-config__eyebrow">United States availability</p>' +
      '<h2>This model is not currently offered in the United States</h2>' +
      '<p>Explore the outdoor sauna models currently available for US delivery, or contact our specialists for help choosing the closest alternative.</p>' +
      '<div><a href="/collections/outdoor-saunas">Explore US outdoor saunas</a>' +
      '<button type="button" class="popup-form-btn">Talk to a specialist</button></div>' +
      '</section>';
  }

  // saunamo-us-harvia-single-topfold-20260826
  function fixHarviaHeaterTopfold() {
    var key = (window.location.pathname || '').replace(/\/+$/, '');
    var specs = {
      '/products/harvia-kip-electric-sauna-heater': [['TYPE','Wall-mounted'],['OUTPUT','4.5 / 6 / 8 kW'],['STONES','Sold separately'],['WARRANTY','3 years']],
      '/products/harvia-cilindro-wifi-sauna-heater': [['TYPE','Floor-standing column'],['OUTPUT','7 / 9 / 11 kW'],['CONTROL','Xenio WiFi'],['WARRANTY','3 years']],
      '/products/harvia-m3-wood-burning-sauna-heater': [['TYPE','Wood-burning'],['FIT','Smaller outdoor saunas'],['CHIMNEY','Sold separately'],['WARRANTY','3 years']],
      '/products/harvia-linear-compact-18-wood-burning-sauna-heater': [['TYPE','Compact wood-burning'],['OUTPUT','18 kW'],['CHIMNEY','Sold separately'],['WARRANTY','3 years']]
    }[key];
    if (!specs) return;
    // saunamo-us-harvia-native-blocks-hidden-20260826
    Array.prototype.forEach.call(document.querySelectorAll('.main-product-section .product-information--inner'), function (inner) {
      Array.prototype.forEach.call(inner.children, function (block) {
        if (!block.classList.contains('custom-liquid')) block.style.setProperty('display', 'none', 'important');
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('.sm-wellness-topfold__top-badge'), function (badge, index) {
      if (!specs[index]) return;
      var label = badge.querySelector('.sm-wellness-topfold__top-badge-label');
      var value = badge.querySelector('.sm-wellness-topfold__top-badge-value');
      if (label) label.textContent = specs[index][0];
      if (value) value.textContent = specs[index][1];
    });
  }

  function applyUsMarket() {
    document.documentElement.lang = 'en';
    document.title = document.title.replace('Saunas, Ice Baths, Hot Tubs at Best Prices', 'Saunas for Home and Business');
    restoreUsCatalogLinks(document);
    ensureUsCompleteCollectionCards();
    enforceUsIceBathCategoryCard();
    installUsCategoryVisibilityGuard();
    hideRestrictedLinks(document);
    ensureUsIceBathNavigation();
    installUsIceBathNavigationGuard();
    repairUsCollectionProductCards();
    centerUsInfraredProductGrid();
    polishUsHeaterLayouts();
    hideRestrictedComparisonModels(document);
    hideNonSaunaHomepageSections(document);
    fixHarviaHeaterTopfold();
    replaceUnavailableUsConfigurator();
    hideUsCollectionEditorialSections();
    replaceCollectionImage(document);
    setEnglishLanguageUi(document);
    forceUsConfigurator(document);
    installUsConfiguratorClickGuard();
    installUsCustomConfiguratorViewGuard();
    translateB2bPage(document.body);
    translateTree(document.body);
    translateB2bPage(document.body);
    rewriteUsReceiveOrAssemble(document.body);
    translateUsAttributes(document);
    removeUnsupportedUsContent(document);
    removeUsAssemblyGuidance();
    hideUsShowroom(document);
    installUsConfiguratorDepositGuard();
    presentAuraAsReadyPackage(document);
    updateUsQuoteForm(document);
    installUsDepositCta(document);
  }

  var style = document.createElement('style');
  style.textContent = '[data-saunamo-us-hidden="true"],[data-saunamo-us-delivery-note],#cube220-contraste{display:none!important}header li:has(>a[href="/collections/ice-baths"]),header li:has(>a[href="/collections/banheiras-de-gelo"]){display:block!important}.saunamo-native-language__button{cursor:default!important}.saunamo-us-deposit-cta{display:flex;align-items:center;justify-content:center;width:100%;min-height:54px;margin:0 0 14px;padding:14px 24px;border-radius:999px;background:#2f3438;color:#fff;text-decoration:none;font:inherit}.saunamo-us-deposit-cta:hover{background:#121212;color:#fff}[data-saunamo-us-category-grid]{justify-content:center!important}[data-saunamo-us-category-grid] a[href="/collections/infrared-saunas"] img{object-position:center center!important}[data-saunamo-us-category-grid] .collection-card--img{background:#fff}.phs-wrapper a[href*="harvia-m3-wood-burning-sauna-heater"] img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:22px!important;box-sizing:border-box!important}#dyn-configurador[data-saunamo-us-aura-ready="true"]{background:#f3eeea;padding:56px 20px}#dyn-configurador[data-saunamo-us-aura-ready="true"] .wzc-inner{max-width:1000px}#dyn-configurador[data-saunamo-us-aura-ready="true"] .wzc-intro{display:block!important;max-width:760px;margin:0 auto 32px;text-align:center}#dyn-configurador[data-saunamo-us-aura-ready="true"] #wzDynTitle{margin:0 0 10px;font-size:clamp(28px,4vw,42px);line-height:1.1}#dyn-configurador[data-saunamo-us-aura-ready="true"] #wzDynIntro{max-width:640px;margin:0 auto;color:#676b6e;font-size:16px;line-height:1.55}.saunamo-us-aura-inclusions{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:9px 22px;margin:0;padding:2px 0 4px;list-style:none}.saunamo-us-aura-inclusions li{position:relative;padding-left:20px;font-size:14px;line-height:1.35}.saunamo-us-aura-inclusions li:before{content:"✓";position:absolute;left:0;color:#19a957;font-weight:700}@media(max-width:749px){#dyn-configurador[data-saunamo-us-aura-ready="true"] .wzc-intro{margin-bottom:24px}.saunamo-us-aura-inclusions{grid-template-columns:1fr}}/* saunamo-us-aura-header-images-20260826 */#dyn-configurador[data-saunamo-us-aura-view="card"] #wzDynBody{display:none!important}.saunamo-us-aura-ready-card{width:min(100%,390px);margin:0 auto;overflow:hidden;border-radius:16px;background:#fff;color:#202326;box-shadow:0 1px 0 rgba(32,35,38,.04)}.saunamo-us-aura-ready-card[hidden]{display:none!important}.saunamo-us-aura-ready-card__media{position:relative;height:230px;overflow:hidden;background:#ddd}.saunamo-us-aura-ready-card__media>img{display:block;width:100%;height:100%;object-fit:cover;object-position:center}.saunamo-us-aura-ready-card__tag{position:absolute;left:12px;top:12px;padding:9px 14px;border-radius:999px;background:#33383c;color:#fff;font-size:11px;line-height:1;letter-spacing:.08em}.saunamo-us-aura-ready-card__price{position:absolute;left:12px;right:12px;bottom:12px;display:flex;flex-direction:column;align-items:flex-end;padding:9px 14px;border-radius:12px;background:rgba(255,255,255,.96);text-align:right}.saunamo-us-aura-ready-card__price span,.saunamo-us-aura-ready-card__price small{font-size:10px;line-height:1.35;color:#777}.saunamo-us-aura-ready-card__price strong{font-size:21px;line-height:1.15;font-weight:500}.saunamo-us-aura-ready-card__content{padding:18px 18px 16px}.saunamo-us-aura-ready-card__content h3{margin:0 0 8px;font-size:22px;line-height:1.2}.saunamo-us-aura-ready-card__intro{margin:0 0 14px;color:#666;font-size:14px;line-height:1.55}.saunamo-us-aura-ready-card__content ul{display:grid;gap:8px;margin:0 0 16px;padding:0;list-style:none}.saunamo-us-aura-ready-card__content li{position:relative;padding-left:20px;font-size:13px;line-height:1.35}.saunamo-us-aura-ready-card__content li:before{content:"✓";position:absolute;left:0;top:0;color:#19a957;font-weight:700}.saunamo-us-aura-ready-card__content button{display:flex;width:100%;min-height:48px;align-items:center;justify-content:center;gap:8px;border:0;border-radius:10px;background:#30353a;color:#fff;font:inherit;font-size:14px;cursor:pointer}.saunamo-us-aura-ready-card__content button:hover{background:#16191c}.saunamo-us-aura-ready-card__deposit{position:relative;margin:12px 0 0;padding-left:18px;color:#777;font-size:10px;line-height:1.45}.saunamo-us-aura-ready-card__deposit:before{content:"♢";position:absolute;left:2px;top:0}@media (max-width:749px){#dyn-configurador[data-saunamo-us-aura-ready="true"]{padding:34px 14px}.saunamo-us-aura-ready-card__media{height:210px}.saunamo-us-aura-ready-card__content{padding:17px 16px 15px}}@media (min-width:1068px){[data-saunamo-us-infrared-products="true"]{grid-template-columns:repeat(3,minmax(0,1fr))!important;max-width:780px!important;margin-left:auto!important;margin-right:auto!important}}';
  document.head.appendChild(style);

  var heaterLayoutStyle = document.createElement('style');
  heaterLayoutStyle.textContent = '[data-saunamo-us-heater-grid] .phs-slider{align-items:stretch!important}[data-saunamo-us-heater-grid] .product__card__phs{display:flex!important;flex-direction:column!important;height:auto!important}[data-saunamo-us-heater-grid] .phs-card{display:flex!important;flex:1!important;flex-direction:column!important}[data-saunamo-us-heater-grid] .phs-top{min-height:78px!important}[data-saunamo-us-heater-grid] .phs-features{flex:1!important}[data-saunamo-us-heater-grid] .feature_coll_btn_box{margin-top:auto!important}[data-saunamo-us-m3-gallery] .media-ratio img{object-fit:contain!important;object-position:center!important;padding:28px!important;box-sizing:border-box!important;background:#fff!important}[data-saunamo-us-aura-gallery] .media-ratio img{object-position:center center!important}';
  document.head.appendChild(heaterLayoutStyle);

  var auraBundleStyle = document.createElement('style');
  // saunamo-us-aura-lumia-flow-20260826
  // saunamo-us-aura-delivery-other-20260826
  auraBundleStyle.textContent = '#dyn-configurador[data-saunamo-us-aura-view="detail"] #wzDynBody{display:none!important}.saunamo-us-aura-ready-detail{width:min(100%,860px);margin:0 auto 18px}.saunamo-us-aura-ready-detail[hidden]{display:none!important}.saunamo-us-aura-ready-detail__back{display:block;margin:0 auto 14px;width:min(100%,860px);padding:0;border:0;background:transparent;color:#6f7478;text-align:left;font:inherit;font-size:13px;cursor:pointer}.saunamo-us-aura-ready-detail .wz-rec-bundle__head{align-items:start}.saunamo-us-aura-ready-detail .wz-rec-bundle__kit-thumb{width:100%;height:112px}.saunamo-us-aura-ready-detail .wz-rec-bundle__kit-thumb img{display:block;width:100%;height:100%;object-fit:cover;object-position:center;border-radius:inherit}.saunamo-us-aura-ready-detail .wz-rec-bundle__kit-thumb img[alt="Ambient LED lighting"]{object-position:65% 55%}/* saunamo-us-aura-led-panel-20260828 */.saunamo-us-aura-ready-detail .wz-rec-bundle__kit-label{display:flex;align-items:flex-start;gap:6px}.saunamo-us-aura-kit-check{color:#19a957;font-weight:700}.saunamo-us-aura-ready-detail [hidden]{display:none!important}.saunamo-us-aura-ready-detail .wz-rec-inline{padding-top:4px}.saunamo-us-aura-ready-detail .wz-summary-lead-form{margin:0;padding:0;background:transparent;border:0;box-shadow:none}.saunamo-us-aura-ready-detail .wz-summary-lead-intro,.saunamo-us-aura-ready-detail .wz-summary-lead-field label,.saunamo-us-aura-ready-detail .wz-summary-lead-field:has(textarea),.saunamo-us-aura-ready-detail .wz-summary-lead-privacy{display:none!important}.saunamo-us-aura-ready-detail .wz-summary-lead-fields{display:grid;grid-template-columns:1fr;gap:10px}.saunamo-us-aura-ready-detail .wz-summary-lead-field input{min-height:48px}.saunamo-us-aura-ready-detail .wz-rec-buy-full{margin:12px 0 8px;text-align:center}.saunamo-us-aura-payment-steps{display:grid;gap:7px;margin:4px 0 16px;padding:0;list-style:none}.saunamo-us-aura-payment-steps li{display:flex;align-items:center;gap:8px;padding:0;background:transparent;font-size:13px;line-height:1.35}.saunamo-us-aura-payment-steps strong{display:grid;flex:0 0 20px;width:20px;height:20px;place-items:center;border-radius:50%;background:#30353a;color:#fff;font-size:11px}.saunamo-us-aura-ready-detail .wz-summary-lead-submit{width:100%;min-height:50px;border-radius:12px;background:#a8d9af;color:#fff}.saunamo-us-aura-ready-detail .wz-summary-lead-submit:hover{background:#8dcc97}.saunamo-us-aura-ready-detail .wz-rec-other__input{width:100%;min-height:48px;padding:12px 14px;border:1px solid rgba(18,18,18,.18);border-radius:12px;font:inherit}.saunamo-us-aura-ready-detail .wz-rec-region__menu{z-index:4}[data-saunamo-us-category-grid] a[href="/collections/infrared-saunas"] img{object-position:center 60%!important}header .megamenu-items a[href="/collections/infrared-saunas"] img{object-position:center 60%!important}/* saunamo-us-megamenu-infrared-center-20260826 */@media(max-width:749px){.saunamo-us-aura-ready-detail .wz-rec-bundle__body{padding:18px 14px}.saunamo-us-aura-ready-detail .wz-rec-bundle__head{grid-template-columns:1fr}.saunamo-us-aura-ready-detail .wz-rec-bundle__price{text-align:left}.saunamo-us-aura-ready-detail .wz-rec-bundle__kit{grid-template-columns:repeat(2,minmax(0,1fr))}.saunamo-us-aura-ready-detail .wz-rec-bundle__kit-thumb{height:104px}.saunamo-us-aura-payment-steps{grid-template-columns:1fr}}';
  document.head.appendChild(auraBundleStyle);

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyUsMarket();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyUsMarket);
  else applyUsMarket();
  [500, 1500, 4000, 8000].forEach(function (delay) { window.setTimeout(applyUsMarket, delay); });
})();
